
// // import React, { useState, useEffect, useCallback } from 'react';
// // import { useAuth } from '../App';
// // import Layout from '../components/Layout';
// // import { Card, CardContent } from '../components/ui/card';
// // import { Button } from '../components/ui/button';
// // import { Badge } from '../components/ui/badge';
// // import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../components/ui/select';
// // import { toast } from 'sonner';
// // import { UserCheck, UserX, FileText, X } from 'lucide-react';
// // import { Link } from 'react-router-dom';

// // export default function Users() {
// //   const [users, setUsers] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [payrollModal, setPayrollModal] = useState({ 
// //     open: false, 
// //     user: null, 
// //     prestations: [], 
// //     selectedMonth: null,  
// //     selectedYear: new Date().getFullYear().toString(),
// //     filteredPrestations: [],
// //     totals: { gross: 0, discount: 0, net: 0 },
// //     hours: {}
// //   });
// //   const [payrollLoading, setPayrollLoading] = useState(false);

// //   const [searchTerm, setSearchTerm] = useState("");
// //   const [roleFilter, setRoleFilter] = useState("all");
// //   const [statusFilter, setStatusFilter] = useState("all");
// //   const { axiosInstance, user: currentUser, logout } = useAuth();

// //   const TARGET_ETAB_ID = "19036569-8d87-48c0-a886-36def8770f49";
// //   const TARGET_ETAB_NAME = "la charmille";

// //   const targetEtabName =
// //     payrollModal.prestations
// //       .filter(p => String(p.etablissement_id) === String(TARGET_ETAB_ID))
// //       .map(p => p.etablissement_name)
// //       .find(Boolean) || "la charmille";

// //   useEffect(() => {
// //     fetchUsers();
// //   }, []);

// //   console.log(payrollModal.prestations);

// //   const fetchUsers = async () => {
// //     setLoading(true);
// //     try {
// //       const response = await axiosInstance.get('/users');
// //       const mappedUsers = response.data.map(u => ({
// //         ...u,
// //         id: u.id || u._id,
// //         first_name: u.first_name || '',
// //         last_name: u.last_name || '',
// //         status: u.status || 'pending',
// //       }));
// //       setUsers(mappedUsers);
// //     } catch (error) {
// //       if (error.response?.status === 401) {
// //         toast.error('Session expirée. Veuillez vous reconnecter.');
// //         logout();
// //       } else if (error.response?.status === 403) {
// //         toast.error('Accès refusé : vous n\'êtes pas admin.');
// //       } else {
// //         toast.error('Échec du chargement des utilisateurs');
// //       }
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   const formatDuration = (minutesFloat) => {
// //     if (minutesFloat == null || isNaN(minutesFloat)) return "—";
// //     const totalMinutes = Math.round(minutesFloat);
// //     const h = Math.floor(totalMinutes / 60);
// //     const m = totalMinutes % 60;
// //     return `${h}h ${m}m`;
// //   };


// // const getPrestationDetails = (p) => {
// //   const dureePayee = p.dureeMinutes || 0;
// //   const actualDuration = p.actual_duration || 0;
// //   const isTargetEtab = p.etablissement_id === TARGET_ETAB_ID;
// //   const isCompleted = p.status === "completed";

// //   const dureeBrute = isTargetEtab ? dureePayee + 30 : dureePayee;

// //   let dureeFinal = p.actual_duration_payee || actualDuration || dureePayee;
// //   let pauseDeduite = p.pause_non_payee_minutes || 0;

// //   if (isTargetEtab && p.pause_non_payee_appliquee) {
// //     pauseDeduite = 30;
// //   }

// //   return {
// //     dureeInitiale: dureeBrute,
// //     dureeBrute,
// //     dureeFinal,
// //     pauseDeduite,
// //     isTargetEtab,
// //     isCompleted,
// //   };
// // };

// //   const calculateTotals = (prestations, role) => {
// //     const completedPrestations = prestations.filter(
// //       (p) => p.status === "completed"
// //     );

// //     const gross = completedPrestations.reduce((acc, p) => {
// //       return acc + Number(p.gain_final ?? p.final_rate ?? 0);
// //     }, 0);

// //     const discountRate = role === "nurse" ? 0.09 : 0.07;

// //     const discount = gross * discountRate;
// //     const net = gross - discount;

// //     return { gross, discount, net, discountRate };
// //   };


// //   const analyzeHours = (prestations) => {
// //     let totalPrev = 0, weekPrev = 0, weekendPrev = 0;
// //     let totalReal = 0, weekReal = 0, weekendReal = 0;

// //     prestations.forEach(p => {
// //       const dt = new Date(p.dateStart);
// //       const day = dt.getDay();
// //       const planned = p.dureeMinutes || 0;
// //       const actual = Math.round(p.actual_duration || 0);
// //       totalPrev += planned;
// //       totalReal += actual;
// //       if (day === 0 || day === 6) {
// //         weekendPrev += planned;
// //         weekendReal += actual;
// //       } else {
// //         weekPrev += planned;
// //         weekReal += actual;
// //       }
// //     });

// //     const filteredUsers = users.filter((u) => {
// //       const text = (searchTerm || "").toLowerCase();
// //       const matchText =
// //         u.first_name.toLowerCase().includes(text) ||
// //         u.last_name.toLowerCase().includes(text) ||
// //         (u.email || "").toLowerCase().includes(text);

// //       const matchRole = roleFilter === "all" ? true : u.role === roleFilter;
// //       const matchStatus = statusFilter === "all" ? true : u.status === statusFilter;

// //       return matchText && matchRole && matchStatus;
// //     });

// //     return {
// //       totalHoursPlanned: (totalPrev / 60).toFixed(2),
// //       weekHoursPlanned: (weekPrev / 60).toFixed(2),
// //       weekendHoursPlanned: (weekendPrev / 60).toFixed(2),
// //       totalHoursReal: (totalReal / 60).toFixed(2),
// //       weekHoursReal: (weekReal / 60).toFixed(2),
// //       weekendHoursReal: (weekendReal / 60).toFixed(2),
// //     };
// //   };

// //   const fetchUserPayrolls = async (userId, user) => {
// //     setPayrollLoading(true);
// //     try {
// //       // const response = await axiosInstance.post('/prestations/user', { user_id: userId });
// //       const response = await axiosInstance.get(`/prestations/user/${userId}`);
// //       // const response = await axiosInstance.get(`/prestations/user/${userId}`);
// //       const allPrestations = response.data;
      
// //       // Filtrer immédiatement
// //       const filtered = allPrestations.filter(p => {
// //         const dt = new Date(p.dateStart);
// //         const monthMatch = payrollModal.selectedMonth ? 
// //           (dt.getMonth() + 1).toString().padStart(2, "0") === payrollModal.selectedMonth : true;
// //         const yearMatch = payrollModal.selectedYear ? 
// //           dt.getFullYear().toString() === payrollModal.selectedYear : true;
// //         return monthMatch && yearMatch;
// //       });
      
// //       // const totals = calculateTotals(filtered);
// //       const totals = calculateTotals(filtered, user.role);
// //       const hours = analyzeHours(filtered);
      
// //       setPayrollModal({
// //         open: true, 
// //         user, 
// //         prestations: allPrestations,
// //         filteredPrestations: filtered,
// //         selectedMonth: null,  // ✅ null pour "Tous les mois"
// //         selectedYear: new Date().getFullYear().toString(),
// //         totals,
// //         hours
// //       });
// //       toast.success(`Fiche de paie de ${user.first_name} ${user.last_name} chargée`);
// //     } catch (error) {
// //       toast.error('Erreur lors du chargement de la fiche de paie');
// //     } finally {
// //       setPayrollLoading(false);
// //     }
// //   };

// //   const updateFilters = useCallback((month, year) => {
// //     const filtered = payrollModal.prestations.filter(p => {
// //       const dt = new Date(p.dateStart);
// //       const monthMatch = month ? (dt.getMonth() + 1).toString().padStart(2, "0") === month : true;
// //       const yearMatch = year ? dt.getFullYear().toString() === year : true;
// //       return monthMatch && yearMatch;
// //     });
    
// //     // const totals = calculateTotals(filtered);
// //     const totals = calculateTotals(filtered, payrollModal.user?.role);
// //     const hours = analyzeHours(filtered);
    
// //     setPayrollModal(prev => ({
// //       ...prev,
// //       selectedMonth: month || null,  // ✅ null si month vide
// //       selectedYear: year,
// //       filteredPrestations: filtered,
// //       totals,
// //       hours
// //     }));
// //   }, [payrollModal.prestations]);

// //   const closePayrollModal = () => {
// //     setPayrollModal({ 
// //       open: false, 
// //       user: null, 
// //       prestations: [], 
// //       selectedMonth: null,
// //       selectedYear: new Date().getFullYear().toString(),
// //       filteredPrestations: [],
// //       totals: { gross: 0, discount: 0, net: 0 },
// //       hours: {}
// //     });
// //   };

// //   // ... (handleApprove, handleReject, getStatusBadge, getRoleBadge restent identiques)

// //   const handleApprove = async (userId, e) => {
// //     e.stopPropagation();
// //     try {
// //       await axiosInstance.post(`/users/${userId}/approve`);
// //       toast.success('Utilisateur approuvé');
// //       fetchUsers();
// //     } catch {
// //       toast.error('Échec de l\'approbation');
// //     }
// //   };

// //   const handleReject = async (userId, e) => {
// //     e.stopPropagation();
// //     try {
// //       await axiosInstance.post(`/users/${userId}/reject`);
// //       toast.success('Utilisateur rejeté');
// //       fetchUsers();
// //     } catch {
// //       toast.error('Échec du rejet');
// //     }
// //   };

// //   const getStatusBadge = (status) => {
// //     const variants = {
// //       pending: 'bg-orange-100 text-orange-700',
// //       approved: 'bg-emerald-100 text-emerald-700',
// //       rejected: 'bg-red-100 text-red-700',
// //     };
// //     return (
// //       <Badge className={variants[status] || 'bg-gray-500 text-white'}>
// //         {status === 'pending' ? 'En attente' : status === 'approved' ? 'Approuvé' : 'Rejeté'}
// //       </Badge>
// //     );
// //   };
// //   // 
// //   const handlePaymentNotification = async () => {
// //     if (!payrollModal.user) {
// //       toast.error("Aucun utilisateur sélectionné");
// //       return;
// //     }
// //     try {
// //       await axiosInstance.post(`/users/${payrollModal.user.id}/payment-notification`);
// //       toast.success("Notification de virement envoyée");
// //     } catch (e) {
// //       toast.error("Erreur lors de l'envoi de la notification");
// //     }
// //   };


// //   // const getRoleBadge = (role) => (
// //   //   <Badge className="bg-amber-500 text-white">
// //   //     {role === 'nurse' ? 'Infirmier' : role === 'caregiver' ? 'Aide-soignant' : 'Admin'}
// //   //   </Badge>
// //   // );

// //   if (loading) {
// //     return (
// //       <Layout title="Gestion des utilisateurs">
// //         <div className="flex justify-center py-12">
// //           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
// //         </div>
// //       </Layout>
// //     );
// //   }

// //   const filteredUsers = users.filter((u) => {
// //     const text = (searchTerm || "").toLowerCase();
// //     const matchText =
// //       u.first_name.toLowerCase().includes(text) ||
// //       u.last_name.toLowerCase().includes(text) ||
// //       (u.email || "").toLowerCase().includes(text);

// //     const matchRole = roleFilter === "all" ? true : u.role === roleFilter;
// //     const matchStatus = statusFilter === "all" ? true : u.status === statusFilter;

// //     return matchText && matchRole && matchStatus;
// //   });


// //   const handleDeleteUser = async (userId, e) => {
// //     e.stopPropagation();
// //     if (!window.confirm("Supprimer définitivement cet utilisateur ?")) return;

// //     try {
// //       await axiosInstance.delete(`/users/admin/${userId}`);
// //       toast.success("Utilisateur supprimé");
// //       setUsers((prev) => prev.filter((u) => u.id !== userId));
// //     } catch (error) {
// //       toast.error(error.response?.data?.detail || "Échec de la suppression");
// //     }
// //   };

// //   const stats = {
// //     total: users.length,
// //     nurses: users.filter(u => u.role === "nurse").length,
// //     caregivers: users.filter(u => u.role === "caregiver").length,
// //     admins: users.filter(u => u.role === "admin").length,
// //     approved: users.filter(u => u.status === "approved").length,
// //     pending: users.filter(u => u.status === "pending").length,
// //   };

// //   const getRoleBadge = (role) => {

// //     switch(role){

// //     case "nurse":
// //     return (
// //     <Badge className="bg-blue-100 text-blue-700">
// //     🩺 Infirmier
// //     </Badge>
// //     )

// //     case "caregiver":
// //     return (
// //     <Badge className="bg-green-100 text-green-700">
// //     🧑‍⚕️ Aide-soignant
// //     </Badge>
// //     )

// //     default:
// //     return (
// //     <Badge className="bg-gray-100 text-gray-700">
// //     🛡 Admin
// //     </Badge>
// //     )

// //     }

// //     }

// //   return (
// //     <Layout title="Gestion des utilisateurs">
// //       <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-6">
// //         <Card className="border-0 shadow-md">
// //           <CardContent className="p-5">
// //             <p className="text-gray-500 text-sm">Total soignants</p>
// //             <p className="text-3xl font-bold">{stats.total}</p>
// //           </CardContent>
// //         </Card>

// //         <Card className="border-0 shadow-md">
// //           <CardContent className="p-5">
// //             <p className="text-gray-500 text-sm">Infirmiers</p>
// //             <p className="text-3xl font-bold text-blue-600">{stats.nurses}</p>
// //           </CardContent>
// //         </Card>

// //         <Card className="border-0 shadow-md">
// //           <CardContent className="p-5">
// //             <p className="text-gray-500 text-sm">Aides-soignants</p>
// //             <p className="text-3xl font-bold text-green-600">{stats.caregivers}</p>
// //           </CardContent>
// //         </Card>

// //         <Card className="border-0 shadow-md">
// //           <CardContent className="p-5">
// //             <p className="text-gray-500 text-sm">Approuvés</p>
// //             <p className="text-3xl font-bold text-emerald-600">{stats.approved}</p>
// //           </CardContent>
// //         </Card>

// //         <Card className="border-0 shadow-md">
// //           <CardContent className="p-5">
// //             <p className="text-gray-500 text-sm">En attente</p>
// //             <p className="text-3xl font-bold text-orange-500">{stats.pending}</p>
// //           </CardContent>
// //         </Card>

// //         </div>

// //       {/* Liste users identique */}
// //       <div className="mb-4 flex flex-col md:flex-row gap-3 md:items-end">
// //         {/* Filtre texte */}
// //         <div className="flex-1">
// //           <label className="block text-sm font-medium text-amber-900 mb-1">
// //             Rechercher
// //           </label>
// //           <input
// //             type="text"
// //             className="w-full border border-amber-200 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500"
// //             placeholder="Nom, prénom ou email…"
// //             value={searchTerm}
// //             onChange={(e) => setSearchTerm(e.target.value)}
// //           />
// //         </div>

// //         {/* Filtre rôle */}
// //         <div>
// //           <label className="block text-sm font-medium text-amber-900 mb-1">
// //             Rôle
// //           </label>
// //           <Select
// //             value={roleFilter}
// //             onValueChange={(v) => setRoleFilter(v)}
// //           >
// //             <SelectTrigger className="w-[160px] bg-white text-amber-900">
// //               <SelectValue />
// //             </SelectTrigger>
// //             <SelectContent>
// //               <SelectItem value="all">Tous</SelectItem>
// //               <SelectItem value="nurse">Infirmier</SelectItem>
// //               <SelectItem value="caregiver">Aide-soignant</SelectItem>
// //               <SelectItem value="admin">Admin</SelectItem>
// //             </SelectContent>
// //           </Select>
// //         </div>

// //         {/* Filtre statut */}
// //         <div>
// //           <label className="block text-sm font-medium text-amber-900 mb-1">
// //             Statut
// //           </label>
// //           <Select
// //             value={statusFilter}
// //             onValueChange={(v) => setStatusFilter(v)}
// //           >
// //             <SelectTrigger className="w-[160px] bg-white text-amber-900">
// //               <SelectValue />
// //             </SelectTrigger>
// //             <SelectContent>
// //               <SelectItem value="all">Tous</SelectItem>
// //               <SelectItem value="pending">En attente</SelectItem>
// //               <SelectItem value="approved">Approuvé</SelectItem>
// //               <SelectItem value="rejected">Rejeté</SelectItem>
// //             </SelectContent>
// //           </Select>
// //         </div>
// //       </div>

// //       <p className="text-sm text-gray-500 mb-4">
// //         {filteredUsers.length} soignant(s) affiché(s)
// //       </p>

// //       <div className="space-y-4">
// //         {filteredUsers.length === 0 ? (
// //           <Card className="glass-card border-amber-200">
// //             <CardContent className="py-12 text-center text-gray-500">
// //               Aucun utilisateur trouvé
// //             </CardContent>
// //           </Card>
// //         ) : (
// //           filteredUsers.map((user) => (
// //             <Card key={user.id} className="glass-card border-amber-200 cursor-pointer hover:shadow-xl
// // hover:-translate-y-1
// // transition-all
// // duration-300 transition">
// //               <CardContent className="p-7 flex flex-col md:flex-row md:items-center justify-between gap-4">
// //                 <div className="flex items-center space-x-4">
// //                   {user.profile_photo ? (
// //                     console.log("PHOTO =", user.profile_photo),
// //                     <img
// //                       src={
// //                         user.profile_photo.startsWith("http")
// //                           ? user.profile_photo
// //                           : `${process.env.REACT_APP_BACKEND_URL}${user.profile_photo}`
// //                       }
// //                       alt={`${user.first_name} ${user.last_name}`}
// //                       className="w-16 h-16 rounded-full border-2 border-amber-400 object-cover"
// //                     />
// //                   ) : (
// //                     <div className="w-16 h-16 rounded-full bg-amber-200 flex items-center justify-center">
// //                       <span className="text-2xl font-bold text-amber-700">
// //                         {(user.first_name[0] || '') + (user.last_name[0] || '')}
// //                       </span>
// //                     </div>
// //                   )}
// //                   <div>
// //                     {/* <h3 className="text-lg font-semibold text-amber-900">
// //                       {user.first_name} {user.last_name}
// //                     </h3>
// //                     <p className="text-sm text-gray-600">{user.email}</p>
// //                     <p className="text-sm text-gray-600">{user.phone || '—'}</p>
// //                     <div className="flex gap-2 mt-2">
// //                       {getRoleBadge(user.role)}
// //                       {getStatusBadge(user.status)}
// //                     </div> */}
// //                     <h3 className="text-xl font-bold text-gray-900">
// //                       {user.first_name} {user.last_name}
// //                       </h3>

// //                       <div className="flex gap-2 mt-2">
// //                       {getRoleBadge(user.role)}
// //                       {getStatusBadge(user.status)}
// //                       </div>

// //                       <p className="text-gray-600 mt-3">
// //                       📧 {user.email}
// //                       </p>

// //                       <p className="text-gray-600">
// //                       📞 {user.phone || "Non renseigné"}
// //                       </p>

// //                       <p className="text-gray-500 text-sm mt-2">
// //                       Inscrit le {new Date(user.created_at).toLocaleDateString()}
// //                       </p>
// //                   </div>
// //                 </div>
// //                 <hr className="my-4 border-gray-200"/>
// //                 <div className="flex flex-col gap-3">
// //                   {user.status === 'pending' && (
// //                     <div className="flex gap-2">
// //                       <Button onClick={(e) => handleApprove(user.id, e)} className="bg-green-600 hover:bg-green-700 text-white">
// //                         <UserCheck size={16} className="mr-1" />
// //                         Approuver
// //                       </Button>
// //                       <Button onClick={(e) => handleReject(user.id, e)} variant="destructive">
// //                         <UserX size={16} className="mr-1" />
// //                         Rejeter
// //                       </Button>
// //                     </div>
// //                   )}
// //                   <Link to={`/users/${user.id}`} className="btn btn-outline w-full">
// //                     Voir le profil
// //                   </Link>
// //                   <Button 
// //                     onClick={() => fetchUserPayrolls(user.id, user)}
// //                     disabled={payrollLoading}
// //                     variant="outline"
// //                     className="w-full rounded-xl"
// //                     // className="bg-amber-600 hover:bg-amber-700 text-white flex items-center gap-2 w-full"
// //                   >
// //                     <FileText size={16} />
// //                     {payrollLoading ? 'Chargement...' : 'Fiche de paie'}
// //                   </Button>
// //                    <Button
// //                       onClick={(e) => handleDeleteUser(user.id, e)}
// //                       variant="destructive"
// //                       className="w-full rounded-xl"
// //                     >
// //                       Supprimer
// //                     </Button>
// //                 </div>
// //               </CardContent>
// //             </Card>
// //           ))
// //         )}
// //       </div>

// //       {/* Modal CORRIGÉE */}
// //       {payrollModal.open && (
// //         <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
// //           <div className="bg-white rounded-2xl max-w-6xl max-h-[95vh] w-full flex flex-col shadow-2xl">
// //             <div className="bg-gradient-to-r from-amber-600 to-amber-700 text-white p-6 rounded-t-2xl flex flex-col lg:flex-row lg:items-center justify-between gap-4">
// //               <div>
// //                 <h2 className="text-3xl font-bold mb-1">Fiche de paie détaillée</h2>
// //                 <p className="text-amber-100 text-lg">
// //                   {payrollModal.user?.first_name} {payrollModal.user?.last_name}
// //                 </p>
// //               </div>
// //               <div className="flex items-center gap-3 flex-wrap">
// //                 <div className="flex bg-white/20 backdrop-blur-sm rounded-lg p-2">
// //                   {/* ✅ Select Mois CORRIGÉ : PAS de value="" */}
// //                   <Select 
// //                     value={payrollModal.selectedMonth || ""} 
// //                     onValueChange={(v) => updateFilters(v === "" ? null : v, payrollModal.selectedYear)}
// //                   >
// //                     <SelectTrigger className="w-[140px] bg-white/90 text-amber-900 border-0">
// //                       <SelectValue placeholder="Tous les mois" />
// //                     </SelectTrigger>
// //                     <SelectContent>
// //                       {/* ✅ TOUS les SelectItem ont value NON vide */}
// //                       {Array.from({ length: 12 }).map((_, i) => {
// //                         const value = (i + 1).toString().padStart(2, "0");
// //                         return (
// //                           <SelectItem key={value} value={value}>
// //                             {new Date(0, i).toLocaleString('fr-FR', { month: 'long' })}
// //                           </SelectItem>
// //                         );
// //                       })}
// //                     </SelectContent>
// //                   </Select>
                  
// //                   <Select 
// //                     value={payrollModal.selectedYear} 
// //                     onValueChange={(v) => updateFilters(payrollModal.selectedMonth, v)}
// //                     className="ml-2"
// //                   >
// //                     <SelectTrigger className="w-[110px] bg-white/90 text-amber-900 border-0">
// //                       <SelectValue placeholder="Année" />
// //                     </SelectTrigger>
// //                     <SelectContent>
// //                       {Array.from({ length: 5 }, (_, i) => {
// //                         const year = (2023 + i).toString();
// //                         return <SelectItem key={year} value={year}>{year}</SelectItem>;
// //                       })}
// //                     </SelectContent>
// //                   </Select>
// //                 </div>
// //                 {/* <Button className="bg-white text-amber-700 hover:bg-white/80 font-bold px-6">
// //                   📄 Exporter PDF
// //                 </Button> */}
// //                 <Button onClick={closePayrollModal} variant="ghost" size="sm" className="text-white hover:bg-white/20">
// //                   <X size={24} />
// //                 </Button>
// //               </div>
// //             </div>
            
// //             {/* Reste de la modal identique - tableau + récap */}
// //             <div className="flex-1 overflow-hidden flex flex-col min-h-0">
// //               <div className="p-4 bg-amber-50 border-b border-amber-200">
// //                 <p className="text-sm text-gray-700">
// //                   <b>📋 Important :</b> Pause de 30 min déduite <b>UNIQUEMENT</b> pour les prestations de l'établissement{' '}
// //                   <span className="font-bold text-amber-700">
// //                     {/* {payrollModal.prestations.find(p => p.etablissement_id === TARGET_ETAB_ID)?.etablissement_name || "spécifique"} */}
// //                     {/* {payrollModal.prestations.find(p => p.etablissement_id === TARGET_ETAB_ID)?.etablissement?.name || "spécifique"} */}
// //                       {targetEtabName}
// //                   </span>
// //                 </p>
// //               </div>

// //               <div className="flex-1 overflow-auto p-6">
// //                 <div className="overflow-x-auto">
// //                   <table className="w-full text-xs border border-gray-300">
// //                     <thead className="bg-gradient-to-r from-yellow-400 to-amber-500 sticky top-0">
// //                       <tr>
// //                         <th className="border p-2 text-left font-bold text-white">Date début</th>
// //                         <th className="border p-2 text-left font-bold text-white">Date fin</th>
// //                         <th className="border p-2 text-left font-bold text-white">Description</th>
// //                         <th className="border p-2 text-center font-bold text-white">Durée brute</th>
// //                         <th className="border p-2 text-center font-bold text-white">Pause</th>
// //                         <th className="border p-2 text-center font-bold text-white">Facturée</th>
// //                         <th className="border p-2 text-right font-bold text-white">Montant</th>
// //                         <th className="border p-2 text-center font-bold text-white">Statut</th>
// //                       </tr>
// //                     </thead>
// //                     <tbody>
// //                       {payrollModal.filteredPrestations.length === 0 ? (
// //                         <tr>
// //                           <td colSpan={8} className="border p-8 text-center text-gray-500">
// //                             Aucune prestation pour cette période
// //                           </td>
// //                         </tr>
// //                       ) : (
// //                         payrollModal.filteredPrestations.map((p) => {
// //                           const details = getPrestationDetails(p);

// //                           console.log('DEBUG montant admin', p._id, p.gain_final, p.final_rate);
// //                           // const isCompleted = getPrestationDetails(p);
// //                           return (
// //                             <tr key={p._id} className="hover:bg-yellow-50 border-t">
// //                               <td className="border px-2 py-2">{new Date(p.dateStart).toLocaleDateString()}</td>
// //                               <td className="border px-2 py-2">{new Date(p.dateEnd).toLocaleDateString()}</td>
// //                               <td className="border px-2 py-2 max-w-[150px] truncate">{p.description || "—"}</td>
// //                               <td className="border px-2 py-2 text-center font-medium">{formatDuration(details.dureeInitiale)}</td>
// //                               {/* <td className="border px-2 py-2 text-orange-600 font-bold text-center">
// //                                 {details.pauseDeduite > 0 ? `- ${formatDuration(details.pauseDeduite)}` : "—"}
// //                               </td> */}
// //                               <td className="border px-2 py-2 text-orange-600 font-bold text-center">
// //                                 {(details.pauseDeduite > 0 || (details.isTargetEtab && details.isCompleted))
// //                                   ? `- ${formatDuration(details.pauseDeduite > 0 ? details.pauseDeduite : 30)}`
// //                                   : "—"}
// //                               </td>
// //                               <td className="border px-2 py-2 font-bold text-center">
// //                                 {/* {details.isCompleted && details.dureeFinal != null ? formatDuration(details.dureeFinal) : "—"} */}
// //                                 {details.dureeFinal != null
// //                                   ? formatDuration(p.dureeMinutes)
// //                                   : "—"}
// //                               </td>
// //                               {/* <td className="border px-2 py-2 font-bold text-right text-amber-900 pr-3"> */}
// //                                 {/* {details.isCompleted ? `${Number(p.gain_final ?? 0).toFixed(2)} €` : "—"} */}
// //                                 {/* {details.isCompleted ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €` : "—"} */}
// //                               {/* </td> */}

// //                               {/* <td className="border px-2 py-1 font-semibold text-right"> */}
// //                                 {/* {isCompleted ? `${Number(p.gain_final ?? 0).toFixed(2)} €` : "—"} */}
// //                                 {/* {details.isCompleted ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €` : "—"} */}
// //                                 {/* {(p.gain_final ?? p.final_rate) != null */}
// //                                   {/* // ? `${Number( p.final_rate).toFixed(2)} €` */}
// //                                   {/* // : "—"} */}
// //                               {/* </td> */}

// //                               <td className="border px-2 py-1 font-semibold text-right">
// //                                 {p.status === "completed"
// //                                   ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €`
// //                                   : "—"}
// //                               </td>
// //                               <td className={`border px-2 py-2 text-center text-xs font-semibold ${
// //                                 p.status === "completed" ? "text-green-600 bg-green-100" : 
// //                                 p.status === "in_progress" ? "text-blue-600 bg-blue-100" : 
// //                                 p.status === "assigned" ? "text-amber-600 bg-amber-100" : 
// //                                 p.status === "accepted" ? "text-emerald-600 bg-emerald-100" : "text-gray-500 bg-gray-100"
// //                               }`}>
// //                                 {p.status || "—"}
// //                               </td>
// //                             </tr>
// //                           );
// //                         })
// //                       )}
// //                     </tbody>
// //                   </table>
// //                 </div>
// //               </div>

// //               <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-t border-amber-200 p-6 shrink-0">
// //                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">
// //                   <div>
// //                     <h3 className="font-semibold text-gray-700 mb-2">Prévisionnel :</h3>
// //                     <p>Heures totales : <b>{payrollModal.hours?.totalHoursPlanned || 0} h</b></p>
// //                     <p className="ml-4 text-xs">Semaine : <b>{payrollModal.hours?.weekHoursPlanned || 0} h</b> | Week-end : <b>{payrollModal.hours?.weekendHoursPlanned || 0} h</b></p>
// //                   </div>
// //                   <div>
// //                     <h3 className="font-semibold text-gray-700 mb-2">Effectif :</h3>
// //                     <p>Heures totales : <b>{payrollModal.hours?.totalHoursReal || 0} h</b></p>
// //                     <p className="ml-4 text-xs">Semaine : <b>{payrollModal.hours?.weekHoursReal || 0} h</b> | Week-end : <b>{payrollModal.hours?.weekendHoursReal || 0} h</b></p>
// //                   </div>
// //                   <div className="text-right lg:text-left">
// //                     <h3 className="font-semibold text-gray-700 mb-2">Financier :</h3>
// //                     <p>Total brut : <b>{payrollModal.totals?.gross?.toFixed(2) || 0} €</b></p>
// //                     <p>
// //                       Remise {(payrollModal.totals?.discountRate * 100).toFixed(0)}% :
// //                       <b> -{payrollModal.totals?.discount?.toFixed(2) || 0} €</b>
// //                     </p>
// //                     <p className="text-2xl font-bold text-amber-700 mt-2">
// //                       Net : <b>{payrollModal.totals?.net?.toFixed(2) || 0} €</b>
// //                     </p>
// //                     {/* <Button
// //                       onClick={handlePaymentNotification}
// //                       className="mt-4 bg-emerald-600 hover:bg-emerald-700 text-white w-full"
// //                     >
// //                       Confirmer que le virement est fait & notifier
// //                     </Button> */}
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </div>
// //         </div>
// //       )}
// //     </Layout>
// //   );
// // }




// import React, { useState, useEffect, useCallback } from 'react';
// import { useAuth } from '../App';
// import Layout from '../components/Layout';
// import { Card, CardContent } from '../components/ui/card';
// import { Button } from '../components/ui/button';
// import { Badge } from '../components/ui/badge';
// import { Select, SelectTrigger, SelectValue, SelectContent, SelectItem } from '../components/ui/select';
// import { toast } from 'sonner';
// import { UserCheck, UserX, FileText, X, Download } from 'lucide-react';
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import { Link } from "react-router-dom";

// export default function Users() {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [payrollModal, setPayrollModal] = useState({ 
//     open: false, 
//     user: null, 
//     prestations: [], 
//     selectedMonth: null,  
//     selectedYear: new Date().getFullYear().toString(),
//     filteredPrestations: [],
//     totals: { gross: 0, discount: 0, net: 0 },
//     hours: {}
//   });
//   const [payrollLoading, setPayrollLoading] = useState(false);

//   const [searchTerm, setSearchTerm] = useState("");
//   const [roleFilter, setRoleFilter] = useState("all");
//   const [statusFilter, setStatusFilter] = useState("all");
//   const { axiosInstance, user: currentUser, logout } = useAuth();

//   const TARGET_ETAB_ID = "19036569-8d87-48c0-a886-36def8770f49";
//   const TARGET_ETAB_NAME = "la charmille";

//   const targetEtabName =
//     payrollModal.prestations
//       .filter(p => String(p.etablissement_id) === String(TARGET_ETAB_ID))
//       .map(p => p.etablissement_name)
//       .find(Boolean) || "la charmille";

//   useEffect(() => {
//     fetchUsers();
//   }, []);

//   console.log(payrollModal.prestations);

//   const fetchUsers = async () => {
//     setLoading(true);
//     try {
//       const response = await axiosInstance.get('/users');
//       const mappedUsers = response.data.map(u => ({
//         ...u,
//         id: u.id || u._id,
//         first_name: u.first_name || '',
//         last_name: u.last_name || '',
//         status: u.status || 'pending',
//       }));
//       setUsers(mappedUsers);
//     } catch (error) {
//       if (error.response?.status === 401) {
//         toast.error('Session expirée. Veuillez vous reconnecter.');
//         logout();
//       } else if (error.response?.status === 403) {
//         toast.error('Accès refusé : vous n\'êtes pas admin.');
//       } else {
//         toast.error('Échec du chargement des utilisateurs');
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   const formatDuration = (minutesFloat) => {
//     if (minutesFloat == null || isNaN(minutesFloat)) return "—";
//     const totalMinutes = Math.round(minutesFloat);
//     const h = Math.floor(totalMinutes / 60);
//     const m = totalMinutes % 60;
//     return `${h}h ${m}m`;
//   };


// const getPrestationDetails = (p) => {
//   const dureePayee = p.dureeMinutes || 0;
//   const actualDuration = p.actual_duration || 0;
//   const isTargetEtab = p.etablissement_id === TARGET_ETAB_ID;
//   const isCompleted = p.status === "completed";

//   const dureeBrute = isTargetEtab ? dureePayee + 30 : dureePayee;

//   let dureeFinal = p.actual_duration_payee || actualDuration || dureePayee;
//   let pauseDeduite = p.pause_non_payee_minutes || 0;

//   if (isTargetEtab && p.pause_non_payee_appliquee) {
//     pauseDeduite = 30;
//   }

//   return {
//     dureeInitiale: dureeBrute,
//     dureeBrute,
//     dureeFinal,
//     pauseDeduite,
//     isTargetEtab,
//     isCompleted,
//   };
// };

//   const calculateTotals = (prestations, role) => {
//     const completedPrestations = prestations.filter(
//       (p) => p.status === "completed"
//     );

//     const gross = completedPrestations.reduce((acc, p) => {
//       return acc + Number(p.gain_final ?? p.final_rate ?? 0);
//     }, 0);

//     const discountRate = role === "nurse" ? 0.09 : 0.07;

//     const discount = gross * discountRate;
//     const net = gross - discount;

//     return { gross, discount, net, discountRate };
//   };


//   const analyzeHours = (prestations) => {
//     let totalPrev = 0, weekPrev = 0, weekendPrev = 0;
//     let totalReal = 0, weekReal = 0, weekendReal = 0;

//     prestations.forEach(p => {
//       const dt = new Date(p.dateStart);
//       const day = dt.getDay();
//       const planned = p.dureeMinutes || 0;
//       const actual = Math.round(p.actual_duration || 0);
//       totalPrev += planned;
//       totalReal += actual;
//       if (day === 0 || day === 6) {
//         weekendPrev += planned;
//         weekendReal += actual;
//       } else {
//         weekPrev += planned;
//         weekReal += actual;
//       }
//     });

//     const filteredUsers = users.filter((u) => {
//       const text = (searchTerm || "").toLowerCase();
//       const matchText =
//         u.first_name.toLowerCase().includes(text) ||
//         u.last_name.toLowerCase().includes(text) ||
//         (u.email || "").toLowerCase().includes(text);

//       const matchRole = roleFilter === "all" ? true : u.role === roleFilter;
//       const matchStatus = statusFilter === "all" ? true : u.status === statusFilter;

//       return matchText && matchRole && matchStatus;
//     });

//     return {
//       totalHoursPlanned: (totalPrev / 60).toFixed(2),
//       weekHoursPlanned: (weekPrev / 60).toFixed(2),
//       weekendHoursPlanned: (weekendPrev / 60).toFixed(2),
//       totalHoursReal: (totalReal / 60).toFixed(2),
//       weekHoursReal: (weekReal / 60).toFixed(2),
//       weekendHoursReal: (weekendReal / 60).toFixed(2),
//     };
//   };

//  const fetchUserPayrolls = async (userId, selectedUser) => {
//   setPayrollLoading(true);

//   try {
//     const response = await axiosInstance.get(
//       `/prestations/user/${userId}`
//     );

//     const allPrestations = Array.isArray(response.data)
//       ? response.data
//       : [];

//     console.log("PRESTATIONS REÇUES ADMIN :", allPrestations);
//     console.log("USER ID :", userId);

//     const currentYear = new Date().getFullYear().toString();

//     // Au premier affichage :
//     // tous les mois de l'année actuelle
//     const filtered = allPrestations.filter((p) => {
//       if (!p.dateStart) return false;

//       const dt = new Date(p.dateStart);

//       if (isNaN(dt.getTime())) return false;

//       return dt.getFullYear().toString() === currentYear;
//     });

//     const totals = calculateTotals(
//       filtered,
//       selectedUser?.role
//     );

//     const hours = analyzeHours(filtered);

//     setPayrollModal({
//       open: true,

//       user: selectedUser,

//       // IMPORTANT :
//       // on conserve TOUTES les prestations reçues du backend
//       prestations: allPrestations,

//       // aucun mois sélectionné au départ
//       selectedMonth: null,

//       selectedYear: currentYear,

//       // prestations de l'année actuelle
//       filteredPrestations: filtered,

//       totals,
//       hours
//     });

//     toast.success(
//       `Fiche de paie de ${selectedUser?.first_name || ""} ${
//         selectedUser?.last_name || ""
//       } chargée`
//     );

//   } catch (error) {
//     console.error(
//       "ERREUR CHARGEMENT PRESTATIONS ADMIN :",
//       error
//     );

//     console.error(
//       "RÉPONSE BACKEND :",
//       error?.response?.data
//     );

//     toast.error(
//       error?.response?.data?.detail ||
//       "Erreur lors du chargement de la fiche de paie"
//     );

//   } finally {
//     setPayrollLoading(false);
//   }
// };

//   const updateFilters = useCallback((month, year) => {
//     const filtered = payrollModal.prestations.filter(p => {
//       const dt = new Date(p.dateStart);
//       const monthMatch = month ? (dt.getMonth() + 1).toString().padStart(2, "0") === month : true;
//       const yearMatch = year ? dt.getFullYear().toString() === year : true;
//       return monthMatch && yearMatch;
//     });
    
//     // const totals = calculateTotals(filtered);
//     const totals = calculateTotals(filtered, payrollModal.user?.role);
//     const hours = analyzeHours(filtered);
    
//     setPayrollModal(prev => ({
//       ...prev,
//       selectedMonth: month || null,  // ✅ null si month vide
//       selectedYear: year,
//       filteredPrestations: filtered,
//       totals,
//       hours
//     }));
//   }, [payrollModal.prestations]);

//   const exportAdminPayrollPdf = () => {
//   const selectedUser = payrollModal.user;
//   const prestations = payrollModal.filteredPrestations;

//   if (!selectedUser) {
//     toast.error("Aucun utilisateur sélectionné");
//     return;
//   }

//   if (!prestations || prestations.length === 0) {
//     toast.error("Aucune prestation pour cette période");
//     return;
//   }

//   const doc = new jsPDF("portrait", "pt", "a4");
//   const pageWidth = doc.internal.pageSize.getWidth();

//   const logo = new Image();
//   logo.src = "/sanacare.jpg";

//   logo.onload = () => {
//     // =========================
//     // EN-TÊTE
//     // =========================

//     doc.addImage(logo, "JPEG", 40, 30, 90, 45);

//     doc.setFont("Helvetica", "bold");
//     doc.setFontSize(16);

//     doc.text(
//       "SANA-CARE DIAMOND",
//       pageWidth - 40,
//       50,
//       { align: "right" }
//     );

//     doc.setFontSize(10);
//     doc.setFont("Helvetica", "normal");

//     doc.text(
//       "Avenue Louise 200, 1050 Bruxelles",
//       pageWidth - 40,
//       65,
//       { align: "right" }
//     );

//     doc.text(
//       "Sana-carediamond@outlook.com",
//       pageWidth - 40,
//       80,
//       { align: "right" }
//     );

//     doc.text(
//       "1025.941.977",
//       pageWidth - 40,
//       95,
//       { align: "right" }
//     );

//     doc.text(
//       "BE71 3632 5061 2169",
//       pageWidth - 40,
//       110,
//       { align: "right" }
//     );

//     doc.setLineWidth(1);
//     doc.line(40, 125, pageWidth - 40, 125);

//     // =========================
//     // TITRE
//     // =========================

//     const periode = payrollModal.selectedMonth
//       ? `${payrollModal.selectedMonth}/${payrollModal.selectedYear}`
//       : `Année ${payrollModal.selectedYear}`;

//     doc.setFont("Helvetica", "bold");
//     doc.setFontSize(20);

//     doc.text(
//       `FICHE DE PAIE - ${periode}`,
//       pageWidth / 2,
//       165,
//       { align: "center" }
//     );

//     // =========================
//     // INFORMATIONS SOIGNANT
//     // =========================

//     doc.setFontSize(12);
//     doc.setFont("Helvetica", "bold");
//     doc.text("SOIGNANT :", 40, 205);

//     doc.setFontSize(11);
//     doc.setFont("Helvetica", "normal");

//     doc.text(
//       `Nom : ${selectedUser.first_name || ""} ${selectedUser.last_name || ""}`,
//       40,
//       225
//     );

//     doc.text(
//       `Email : ${selectedUser.email || "—"}`,
//       40,
//       240
//     );

//     doc.text(
//       `Téléphone : ${selectedUser.phone || "—"}`,
//       40,
//       255
//     );

//     doc.text(
//       `Adresse : ${selectedUser.address || "—"}`,
//       40,
//       270
//     );

//     doc.setLineWidth(0.8);
//     doc.line(40, 290, pageWidth - 40, 290);

//     // =========================
//     // TABLEAU
//     // =========================

//     const columns = [
//       "Début",
//       "Fin",
//       "Description",
//       "Durée brute",
//       "Pause déduite",
//       "Durée facturée",
//       "Montant (€)",
//       "Statut"
//     ];

//     const rows = prestations.map((p) => {
//       const details = getPrestationDetails(p);

//       return [
//         new Date(p.dateStart).toLocaleDateString("fr-BE"),

//         new Date(p.dateEnd).toLocaleDateString("fr-BE"),

//         p.description || "—",

//         formatDuration(details.dureeInitiale),

//         (
//           details.pauseDeduite > 0 ||
//           (details.isTargetEtab && details.isCompleted)
//         )
//           ? `- ${formatDuration(
//               details.pauseDeduite > 0
//                 ? details.pauseDeduite
//                 : 30
//             )}`
//           : "—",

//         details.isCompleted && details.dureeFinal != null
//           ? formatDuration(details.dureeFinal)
//           : "—",

//         p.status === "completed"
//           ? Number(
//               p.gain_final ??
//               p.final_rate ??
//               0
//             ).toFixed(2)
//           : "—",

//         p.status || "—"
//       ];
//     });

//     autoTable(doc, {
//       startY: 310,

//       head: [columns],

//       body: rows,

//       styles: {
//         fontSize: 8,
//         cellPadding: 4
//       },

//       headStyles: {
//         fillColor: [212, 235, 235],
//         textColor: 20,
//         fontSize: 9,
//         halign: "center"
//       },

//       margin: {
//         left: 40,
//         right: 40
//       }
//     });

//     // =========================
//     // TOTAUX
//     // =========================

//     const totals = payrollModal.totals;

//     const finalY =
//       (doc.lastAutoTable?.finalY || 310) + 30;

//     doc.setFont("Helvetica", "italic");
//     doc.setFontSize(9);

//     doc.text(
//       `* Pause de 30 min déduite uniquement pour les prestations effectuées dans l'établissement « ${targetEtabName} » (accord spécifique).`,
//       40,
//       finalY
//     );

//     doc.setFont("Helvetica", "bold");
//     doc.setFontSize(14);

//     doc.text(
//       `TOTAL BRUT : ${totals.gross.toFixed(2)} €`,
//       pageWidth - 40,
//       finalY + 25,
//       { align: "right" }
//     );

//     doc.setFont("Helvetica", "normal");

//     doc.text(
//       `Prélèvement (${(
//         totals.discountRate * 100
//       ).toFixed(0)} %) : -${totals.discount.toFixed(2)} €`,
//       pageWidth - 40,
//       finalY + 45,
//       { align: "right" }
//     );

//     doc.setFont("Helvetica", "bold");

//     doc.text(
//       `TOTAL NET : ${totals.net.toFixed(2)} €`,
//       pageWidth - 40,
//       finalY + 65,
//       { align: "right" }
//     );

//     // =========================
//     // NOM DU FICHIER
//     // =========================

//     const safeFirstName =
//       (selectedUser.first_name || "soignant")
//         .replace(/\s+/g, "_");

//     const safeLastName =
//       (selectedUser.last_name || "")
//         .replace(/\s+/g, "_");

//     const month =
//       payrollModal.selectedMonth || "annee";

//     doc.save(
//       `fiche_de_paie_${safeFirstName}_${safeLastName}_${month}_${payrollModal.selectedYear}.pdf`
//     );
//   };

//   logo.onerror = () => {
//     toast.error("Impossible de charger le logo Sana Care");
//   };
// };

//   const closePayrollModal = () => {
//     setPayrollModal({ 
//       open: false, 
//       user: null, 
//       prestations: [], 
//       selectedMonth: null,
//       selectedYear: new Date().getFullYear().toString(),
//       filteredPrestations: [],
//       totals: { gross: 0, discount: 0, net: 0 },
//       hours: {}
//     });
//   };

//   // ... (handleApprove, handleReject, getStatusBadge, getRoleBadge restent identiques)

//   const handleApprove = async (userId, e) => {
//     e.stopPropagation();
//     try {
//       await axiosInstance.post(`/users/${userId}/approve`);
//       toast.success('Utilisateur approuvé');
//       fetchUsers();
//     } catch {
//       toast.error('Échec de l\'approbation');
//     }
//   };

//   const handleReject = async (userId, e) => {
//     e.stopPropagation();
//     try {
//       await axiosInstance.post(`/users/${userId}/reject`);
//       toast.success('Utilisateur rejeté');
//       fetchUsers();
//     } catch {
//       toast.error('Échec du rejet');
//     }
//   };

//   const getStatusBadge = (status) => {
//     const variants = {
//       pending: 'bg-orange-100 text-orange-700',
//       approved: 'bg-emerald-100 text-emerald-700',
//       rejected: 'bg-red-100 text-red-700',
//     };
//     return (
//       <Badge className={variants[status] || 'bg-gray-500 text-white'}>
//         {status === 'pending' ? 'En attente' : status === 'approved' ? 'Approuvé' : 'Rejeté'}
//       </Badge>
//     );
//   };
//   // 
//   const handlePaymentNotification = async () => {
//     if (!payrollModal.user) {
//       toast.error("Aucun utilisateur sélectionné");
//       return;
//     }
//     try {
//       await axiosInstance.post(`/users/${payrollModal.user.id}/payment-notification`);
//       toast.success("Notification de virement envoyée");
//     } catch (e) {
//       toast.error("Erreur lors de l'envoi de la notification");
//     }
//   };


//   // const getRoleBadge = (role) => (
//   //   <Badge className="bg-amber-500 text-white">
//   //     {role === 'nurse' ? 'Infirmier' : role === 'caregiver' ? 'Aide-soignant' : 'Admin'}
//   //   </Badge>
//   // );

//   if (loading) {
//     return (
//       <Layout title="Gestion des utilisateurs">
//         <div className="flex justify-center py-12">
//           <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-amber-600"></div>
//         </div>
//       </Layout>
//     );
//   }

//   const filteredUsers = users.filter((u) => {
//     const text = (searchTerm || "").toLowerCase();
//     const matchText =
//       u.first_name.toLowerCase().includes(text) ||
//       u.last_name.toLowerCase().includes(text) ||
//       (u.email || "").toLowerCase().includes(text);

//     const matchRole = roleFilter === "all" ? true : u.role === roleFilter;
//     const matchStatus = statusFilter === "all" ? true : u.status === statusFilter;

//     return matchText && matchRole && matchStatus;
//   });


//   const handleDeleteUser = async (userId, e) => {
//     e.stopPropagation();
//     if (!window.confirm("Supprimer définitivement cet utilisateur ?")) return;

//     try {
//       await axiosInstance.delete(`/users/admin/${userId}`);
//       toast.success("Utilisateur supprimé");
//       setUsers((prev) => prev.filter((u) => u.id !== userId));
//     } catch (error) {
//       toast.error(error.response?.data?.detail || "Échec de la suppression");
//     }
//   };

//   const stats = {
//     total: users.length,
//     nurses: users.filter(u => u.role === "nurse").length,
//     caregivers: users.filter(u => u.role === "caregiver").length,
//     admins: users.filter(u => u.role === "admin").length,
//     titulaireDomicile: users.filter(
//       u => u.role === "titulaire_domicile"
//     ).length,
//     approved: users.filter(u => u.status === "approved").length,
//     pending: users.filter(u => u.status === "pending").length,
//   };

//   const getRoleBadge = (role) => {
//     switch (role) {
//       case "admin":
//         return (
//           <Badge className="bg-gray-100 text-gray-700">
//             🛡 Admin
//           </Badge>
//         );

//       case "nurse":
//         return (
//           <Badge className="bg-blue-100 text-blue-700">
//             🩺 Infirmier
//           </Badge>
//         );

//       case "caregiver":
//         return (
//           <Badge className="bg-green-100 text-green-700">
//             🧑‍⚕️ Aide-soignant
//           </Badge>
//         );

//       case "titulaire_domicile":
//         return (
//           <Badge className="bg-cyan-100 text-cyan-700">
//             🏠 Titulaire soins à domicile
//           </Badge>
//         );

//       case "coordinateur":
//         return (
//           <Badge className="bg-purple-100 text-purple-700">
//             📋 Coordinateur
//           </Badge>
//         );

//       default:
//         return (
//           <Badge className="bg-slate-100 text-slate-700">
//             👤 Utilisateur
//           </Badge>
//         );
//     }
//   };


//   return (
//     <Layout title="Gestion des utilisateurs">
//       <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">
//         <Card className="border-0 shadow-md">
//           <CardContent className="p-5">
//             <p className="text-gray-500 text-sm">Total utilisateurs</p>
//             <p className="text-3xl font-bold">{stats.total}</p>
//           </CardContent>
//         </Card>

//         <Card className="border-0 shadow-md">
//           <CardContent className="p-5">
//             <p className="text-gray-500 text-sm">Infirmiers</p>
//             <p className="text-3xl font-bold text-blue-600">{stats.nurses}</p>
//           </CardContent>
//         </Card>

//         <Card className="border-0 shadow-md">
//           <CardContent className="p-5">
//             <p className="text-gray-500 text-sm">Aides-soignants</p>
//             <p className="text-3xl font-bold text-green-600">{stats.caregivers}</p>
//           </CardContent>
//         </Card>

//         <Card className="border-0 shadow-md">
//           <CardContent className="p-5">
//             <p className="text-gray-500 text-sm">Titulaires domicile</p>
//             <p className="text-3xl font-bold text-cyan-600">
//               {stats.titulaireDomicile}
//             </p>
//           </CardContent>
//         </Card>

//         <Card className="border-0 shadow-md">
//           <CardContent className="p-5">
//             <p className="text-gray-500 text-sm">Approuvés</p>
//             <p className="text-3xl font-bold text-emerald-600">{stats.approved}</p>
//           </CardContent>
//         </Card>

//         <Card className="border-0 shadow-md">
//           <CardContent className="p-5">
//             <p className="text-gray-500 text-sm">En attente</p>
//             <p className="text-3xl font-bold text-orange-500">{stats.pending}</p>
//           </CardContent>
//         </Card>

//         </div>

//       {/* Liste users identique */}
//       <div className="mb-4 flex flex-col md:flex-row gap-3 md:items-end">
//         {/* Filtre texte */}
//         <div className="flex-1">
//           <label className="block text-sm font-medium text-amber-900 mb-1">
//             Rechercher
//           </label>
//           <input
//             type="text"
//             className="w-full border border-amber-200 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-500"
//             placeholder="Nom, prénom ou email…"
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>

//         {/* Filtre rôle */}
//         <div>
//           <label className="block text-sm font-medium text-amber-900 mb-1">
//             Rôle
//           </label>
//           <Select
//             value={roleFilter}
//             onValueChange={(v) => setRoleFilter(v)}
//           >
//             <SelectTrigger className="w-[160px] bg-white text-amber-900">
//               <SelectValue />
//             </SelectTrigger>
//             <SelectContent>
//               <SelectItem value="all">Tous</SelectItem>
//               <SelectItem value="nurse">Infirmier</SelectItem>
//               <SelectItem value="caregiver">Aide-soignant</SelectItem>
//               <SelectItem value="titulaire_domicile">
//                 Titulaire soins à domicile
//               </SelectItem>
//               <SelectItem value="admin">Admin</SelectItem>
//             </SelectContent>
//           </Select>
//         </div>

//         {/* Filtre statut */}
//         <div>
//           <label className="block text-sm font-medium text-amber-900 mb-1">
//             Statut
//           </label>
//           <Select
//             value={statusFilter}
//             onValueChange={(v) => setStatusFilter(v)}
//           >
//             <SelectTrigger className="w-[160px] bg-white text-amber-900">
//               <SelectValue />
//             </SelectTrigger>
//             <SelectContent>
//               <SelectItem value="all">Tous</SelectItem>
//               <SelectItem value="pending">En attente</SelectItem>
//               <SelectItem value="approved">Approuvé</SelectItem>
//               <SelectItem value="rejected">Rejeté</SelectItem>
//             </SelectContent>
//           </Select>
//         </div>
//       </div>

//       <p className="text-sm text-gray-500 mb-4">
//         {filteredUsers.length} utilisateur(s) affiché(s)
//       </p>

//       <div className="space-y-4">
//         {filteredUsers.length === 0 ? (
//           <Card className="glass-card border-amber-200">
//             <CardContent className="py-12 text-center text-gray-500">
//               Aucun utilisateur trouvé
//             </CardContent>
//           </Card>
//         ) : (
//           filteredUsers.map((user) => (
//             <Card key={user.id} className="glass-card border-amber-200 cursor-pointer hover:shadow-xl
// hover:-translate-y-1
// transition-all
// duration-300 transition">
//               <CardContent className="p-7 flex flex-col md:flex-row md:items-center justify-between gap-4">
//                 <div className="flex items-center space-x-4">
//                   {user.profile_photo ? (
//                     console.log("PHOTO =", user.profile_photo),
//                     <img
//                       src={
//                         user.profile_photo.startsWith("http")
//                           ? user.profile_photo
//                           : `${process.env.REACT_APP_BACKEND_URL}${user.profile_photo}`
//                       }
//                       alt={`${user.first_name} ${user.last_name}`}
//                       className="w-16 h-16 rounded-full border-2 border-amber-400 object-cover"
//                     />
//                   ) : (
//                     <div className="w-16 h-16 rounded-full bg-amber-200 flex items-center justify-center">
//                       <span className="text-2xl font-bold text-amber-700">
//                         {(user.first_name[0] || '') + (user.last_name[0] || '')}
//                       </span>
//                     </div>
//                   )}
//                   <div>
//                     <h3 className="text-xl font-bold text-gray-900">
//                       {user.first_name} {user.last_name}
//                       </h3>

//                       {/* <div className="flex gap-2 mt-2">
//                       {getRoleBadge(user.role)}
//                       {getStatusBadge(user.status)}
//                       </div> */}
//                       <div className="flex gap-2 mt-2 flex-wrap">
//                         {getRoleBadge(user.role)}
//                         {getStatusBadge(user.status)}

//                         {user.role !== "admin" && (
//                         <>
//                           {user.documents_complete === true ? (
//                             <Badge className="bg-emerald-100 text-emerald-700">
//                               ✓ Dossier en ordre
//                             </Badge>
//                           ) : user.documents_complete === false ? (
//                             <Badge className="bg-red-100 text-red-700">
//                               ⚠ Dossier pas en ordre
//                             </Badge>
//                           ) : (
//                             <Badge className="bg-gray-100 text-gray-700">
//                               État du dossier inconnu
//                             </Badge>
//                           )}
//                         </>
//                       )}
//                       </div>
//                       {/* {!user.documents_complete && (
//                        */}
//                        {user.role !== "admin" && user.documents_complete === false && (
//                         <div className="mt-3 p-3 rounded-lg bg-red-50 border border-red-200">

//                           <p className="text-sm font-semibold text-red-700">
//                             ⚠ {user.missing_documents?.length || 0} document(s) manquant(s)
//                           </p>

//                           <p className="text-xs text-red-600 mt-1">
//                             {user.missing_documents?.join(" • ")}
//                           </p>

//                         </div>
//                       )}

//                       <p className="text-gray-600 mt-3">
//                       📧 {user.email}
//                       </p>

//                       <p className="text-gray-600">
//                       📞 {user.phone || "Non renseigné"}
//                       </p>

//                       <p className="text-gray-500 text-sm mt-2">
//                       Inscrit le {new Date(user.created_at).toLocaleDateString()}
//                       </p>
//                   </div>
//                 </div>
//                 <hr className="my-4 border-gray-200"/>
//                 <div className="flex flex-col gap-3">
//                   {user.status === 'pending' && (
//                     <div className="flex gap-2">
//                       <Button onClick={(e) => handleApprove(user.id, e)} className="bg-green-600 hover:bg-green-700 text-white">
//                         <UserCheck size={16} className="mr-1" />
//                         Approuver
//                       </Button>
//                       <Button onClick={(e) => handleReject(user.id, e)} variant="destructive">
//                         <UserX size={16} className="mr-1" />
//                         Rejeter
//                       </Button>
//                     </div>
//                   )}
//                   <Link to={`/users/${user.id}`} className="btn btn-outline w-full">
//                     Voir le profil
//                   </Link>
//                   <Button 
//                     onClick={() => fetchUserPayrolls(user.id, user)}
//                     disabled={payrollLoading}
//                     variant="outline"
//                     className="w-full rounded-xl"
//                     // className="bg-amber-600 hover:bg-amber-700 text-white flex items-center gap-2 w-full"
//                   >
//                     <FileText size={16} />
//                     {payrollLoading ? 'Chargement...' : 'Fiche de paie'}
//                   </Button>
//                    <Button
//                       onClick={(e) => handleDeleteUser(user.id, e)}
//                       variant="destructive"
//                       className="w-full rounded-xl"
//                     >
//                       Supprimer
//                     </Button>
//                 </div>
//               </CardContent>
//             </Card>
//           ))
//         )}
//       </div>

//       {/* Modal CORRIGÉE */}
//       {payrollModal.open && (
//         <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">
//           <div className="bg-white rounded-2xl max-w-6xl max-h-[95vh] w-full flex flex-col shadow-2xl">
//             <div className="bg-gradient-to-r from-amber-600 to-amber-700 text-white p-6 rounded-t-2xl flex flex-col lg:flex-row lg:items-center justify-between gap-4">
//               <div>
//                 <h2 className="text-3xl font-bold mb-1">Fiche de paie détaillée</h2>
//                 <p className="text-amber-100 text-lg">
//                   {payrollModal.user?.first_name} {payrollModal.user?.last_name}
//                 </p>
//               </div>
//               <div className="flex items-center gap-3 flex-wrap">
//                 <div className="flex bg-white/20 backdrop-blur-sm rounded-lg p-2">
//                   {/* ✅ Select Mois CORRIGÉ : PAS de value="" */}
//                   <Select 
//                     value={payrollModal.selectedMonth || ""} 
//                     onValueChange={(v) => updateFilters(v === "" ? null : v, payrollModal.selectedYear)}
//                   >
//                     <SelectTrigger className="w-[140px] bg-white/90 text-amber-900 border-0">
//                       <SelectValue placeholder="Tous les mois" />
//                     </SelectTrigger>
//                     <SelectContent>
//                       {/* ✅ TOUS les SelectItem ont value NON vide */}
//                       {Array.from({ length: 12 }).map((_, i) => {
//                         const value = (i + 1).toString().padStart(2, "0");
//                         return (
//                           <SelectItem key={value} value={value}>
//                             {new Date(0, i).toLocaleString('fr-FR', { month: 'long' })}
//                           </SelectItem>
//                         );
//                       })}
//                     </SelectContent>
//                   </Select>
                  
//                   <Select 
//                     value={payrollModal.selectedYear} 
//                     onValueChange={(v) => updateFilters(payrollModal.selectedMonth, v)}
//                     className="ml-2"
//                   >
//                     <SelectTrigger className="w-[110px] bg-white/90 text-amber-900 border-0">
//                       <SelectValue placeholder="Année" />
//                     </SelectTrigger>
//                     <SelectContent>
//                       {Array.from({ length: 5 }, (_, i) => {
//                         const year = (2023 + i).toString();
//                         return <SelectItem key={year} value={year}>{year}</SelectItem>;
//                       })}
//                     </SelectContent>
//                   </Select>
//                 </div>
//                 <Button
//                   onClick={exportAdminPayrollPdf}
//                   disabled={
//                     !payrollModal.filteredPrestations ||
//                     payrollModal.filteredPrestations.length === 0
//                   }
//                   className="bg-white text-slate-700 hover:bg-[#d4ebeb] font-bold px-6 flex items-center gap-2"
//                 >
//                   <Download size={18} />
//                   Télécharger la fiche
//                 </Button>
//                 <Button onClick={closePayrollModal} variant="ghost" size="sm" className="text-white hover:bg-white/20">
//                   <X size={24} />
//                 </Button>
//               </div>
//             </div>
            
//             {/* Reste de la modal identique - tableau + récap */}
//             <div className="flex-1 overflow-hidden flex flex-col min-h-0">
//               <div className="p-4 bg-amber-50 border-b border-amber-200">
//                 <p className="text-sm text-gray-700">
//                   <b>📋 Important :</b> Pause de 30 min déduite <b>UNIQUEMENT</b> pour les prestations de l'établissement{' '}
//                   <span className="font-bold text-amber-700">
//                     {/* {payrollModal.prestations.find(p => p.etablissement_id === TARGET_ETAB_ID)?.etablissement_name || "spécifique"} */}
//                     {/* {payrollModal.prestations.find(p => p.etablissement_id === TARGET_ETAB_ID)?.etablissement?.name || "spécifique"} */}
//                       {targetEtabName}
//                   </span>
//                 </p>
//               </div>

//               <div className="flex-1 overflow-auto p-6">
//                 <div className="overflow-x-auto">
//                   <table className="w-full text-xs border border-gray-300">
//                     <thead className="bg-gradient-to-r from-yellow-400 to-amber-500 sticky top-0">
//                       <tr>
//                         <th className="border p-2 text-left font-bold text-white">Date début</th>
//                         <th className="border p-2 text-left font-bold text-white">Date fin</th>
//                         <th className="border p-2 text-left font-bold text-white">Description</th>
//                         <th className="border p-2 text-center font-bold text-white">Durée brute</th>
//                         <th className="border p-2 text-center font-bold text-white">Pause</th>
//                         <th className="border p-2 text-center font-bold text-white">Facturée</th>
//                         <th className="border p-2 text-right font-bold text-white">Montant</th>
//                         <th className="border p-2 text-center font-bold text-white">Statut</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {payrollModal.filteredPrestations.length === 0 ? (
//                         <tr>
//                           <td colSpan={8} className="border p-8 text-center text-gray-500">
//                             Aucune prestation pour cette période
//                           </td>
//                         </tr>
//                       ) : (
//                         payrollModal.filteredPrestations.map((p) => {
//                           const details = getPrestationDetails(p);

//                           console.log('DEBUG montant admin', p._id, p.gain_final, p.final_rate);
//                           // const isCompleted = getPrestationDetails(p);
//                           return (
//                             <tr key={p._id} className="hover:bg-yellow-50 border-t">
//                               <td className="border px-2 py-2">{new Date(p.dateStart).toLocaleDateString()}</td>
//                               <td className="border px-2 py-2">{new Date(p.dateEnd).toLocaleDateString()}</td>
//                               <td className="border px-2 py-2 max-w-[150px] truncate">{p.description || "—"}</td>
//                               <td className="border px-2 py-2 text-center font-medium">{formatDuration(details.dureeInitiale)}</td>
//                               {/* <td className="border px-2 py-2 text-orange-600 font-bold text-center">
//                                 {details.pauseDeduite > 0 ? `- ${formatDuration(details.pauseDeduite)}` : "—"}
//                               </td> */}
//                               <td className="border px-2 py-2 text-orange-600 font-bold text-center">
//                                 {(details.pauseDeduite > 0 || (details.isTargetEtab && details.isCompleted))
//                                   ? `- ${formatDuration(details.pauseDeduite > 0 ? details.pauseDeduite : 30)}`
//                                   : "—"}
//                               </td>
//                               <td className="border px-2 py-2 font-bold text-center">
//                                 {/* {details.isCompleted && details.dureeFinal != null ? formatDuration(details.dureeFinal) : "—"} */}
//                                 {details.dureeFinal != null
//                                   ? formatDuration(p.dureeMinutes)
//                                   : "—"}
//                               </td>
//                               {/* <td className="border px-2 py-2 font-bold text-right text-amber-900 pr-3"> */}
//                                 {/* {details.isCompleted ? `${Number(p.gain_final ?? 0).toFixed(2)} €` : "—"} */}
//                                 {/* {details.isCompleted ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €` : "—"} */}
//                               {/* </td> */}

//                               {/* <td className="border px-2 py-1 font-semibold text-right"> */}
//                                 {/* {isCompleted ? `${Number(p.gain_final ?? 0).toFixed(2)} €` : "—"} */}
//                                 {/* {details.isCompleted ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €` : "—"} */}
//                                 {/* {(p.gain_final ?? p.final_rate) != null */}
//                                   {/* // ? `${Number( p.final_rate).toFixed(2)} €` */}
//                                   {/* // : "—"} */}
//                               {/* </td> */}

//                               <td className="border px-2 py-1 font-semibold text-right">
//                                 {p.status === "completed"
//                                   ? `${Number(p.gain_final ?? p.final_rate ?? 0).toFixed(2)} €`
//                                   : "—"}
//                               </td>
//                               <td className={`border px-2 py-2 text-center text-xs font-semibold ${
//                                 p.status === "completed" ? "text-green-600 bg-green-100" : 
//                                 p.status === "in_progress" ? "text-blue-600 bg-blue-100" : 
//                                 p.status === "assigned" ? "text-amber-600 bg-amber-100" : 
//                                 p.status === "accepted" ? "text-emerald-600 bg-emerald-100" : "text-gray-500 bg-gray-100"
//                               }`}>
//                                 {p.status || "—"}
//                               </td>
//                             </tr>
//                           );
//                         })
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>

//               <div className="bg-gradient-to-r from-amber-50 to-yellow-50 border-t border-amber-200 p-6 shrink-0">
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">
//                   <div>
//                     <h3 className="font-semibold text-gray-700 mb-2">Prévisionnel :</h3>
//                     <p>Heures totales : <b>{payrollModal.hours?.totalHoursPlanned || 0} h</b></p>
//                     <p className="ml-4 text-xs">Semaine : <b>{payrollModal.hours?.weekHoursPlanned || 0} h</b> | Week-end : <b>{payrollModal.hours?.weekendHoursPlanned || 0} h</b></p>
//                   </div>
//                   <div>
//                     <h3 className="font-semibold text-gray-700 mb-2">Effectif :</h3>
//                     <p>Heures totales : <b>{payrollModal.hours?.totalHoursReal || 0} h</b></p>
//                     <p className="ml-4 text-xs">Semaine : <b>{payrollModal.hours?.weekHoursReal || 0} h</b> | Week-end : <b>{payrollModal.hours?.weekendHoursReal || 0} h</b></p>
//                   </div>
//                   <div className="text-right lg:text-left">
//                     <h3 className="font-semibold text-gray-700 mb-2">Financier :</h3>
//                     <p>Total brut : <b>{payrollModal.totals?.gross?.toFixed(2) || 0} €</b></p>
//                     <p>
//                       Remise {(payrollModal.totals?.discountRate * 100).toFixed(0)}% :
//                       <b> -{payrollModal.totals?.discount?.toFixed(2) || 0} €</b>
//                     </p>
//                     <p className="text-2xl font-bold text-amber-700 mt-2">
//                       Net : <b>{payrollModal.totals?.net?.toFixed(2) || 0} €</b>
//                     </p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </Layout>
//   );
// }



import React, { useState, useEffect, useCallback } from "react";
import { useAuth } from "../App";
import Layout from "../components/Layout";
import { Card, CardContent } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { Badge } from "../components/ui/badge";
import {
  Select,
  SelectTrigger,
  SelectValue,
  SelectContent,
  SelectItem,
} from "../components/ui/select";
import { toast } from "sonner";
import {
  UserCheck,
  UserX,
  FileText,
  X,
  Download,
} from "lucide-react";
import { Link } from "react-router-dom";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export default function Users() {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  const [payrollModal, setPayrollModal] = useState({
    open: false,
    user: null,
    prestations: [],
    selectedMonth: null,
    selectedYear: new Date().getFullYear().toString(),
    filteredPrestations: [],
    totals: {
      gross: 0,
      discount: 0,
      net: 0,
      discountRate: 0,
    },
    hours: {},
  });

  const [payrollLoading, setPayrollLoading] = useState(false);

  const [searchTerm, setSearchTerm] = useState("");
  const [roleFilter, setRoleFilter] = useState("all");
  const [statusFilter, setStatusFilter] = useState("all");

  const { axiosInstance, logout } = useAuth();

  const TARGET_ETAB_ID =
    "19036569-8d87-48c0-a886-36def8770f49";

  const targetEtabName =
    payrollModal.prestations
      .filter(
        (p) =>
          String(p.etablissement_id) ===
          String(TARGET_ETAB_ID)
      )
      .map((p) => p.etablissement_name)
      .find(Boolean) || "la charmille";

  /* =========================================================
     CHARGEMENT USERS
  ========================================================= */

  useEffect(() => {
    fetchUsers();
  }, []);

  const fetchUsers = async () => {
    setLoading(true);

    try {
      const response = await axiosInstance.get("/users");

      const mappedUsers = response.data.map((u) => ({
        ...u,
        id: u.id || u._id,
        first_name: u.first_name || "",
        last_name: u.last_name || "",
        status: u.status || "pending",
      }));

      setUsers(mappedUsers);
    } catch (error) {
      console.error("Erreur users :", error);

      if (error.response?.status === 401) {
        toast.error(
          "Session expirée. Veuillez vous reconnecter."
        );
        logout();
      } else if (error.response?.status === 403) {
        toast.error(
          "Accès refusé : vous n'êtes pas admin."
        );
      } else {
        toast.error(
          "Échec du chargement des utilisateurs"
        );
      }
    } finally {
      setLoading(false);
    }
  };

  /* =========================================================
     FORMAT DURÉE
  ========================================================= */

  const formatDuration = (minutesFloat) => {
    if (
      minutesFloat == null ||
      isNaN(minutesFloat)
    ) {
      return "—";
    }

    const totalMinutes =
      Math.round(minutesFloat);

    const h =
      Math.floor(totalMinutes / 60);

    const m =
      totalMinutes % 60;

    return `${h}h ${m}m`;
  };

  /* =========================================================
     DÉTAIL PRESTATION
  ========================================================= */

  const getPrestationDetails = (p) => {
    const dureePayee =
      Number(p.dureeMinutes) || 0;

    const actualDuration =
      Number(p.actual_duration) || 0;

    const isTargetEtab =
      String(p.etablissement_id) ===
      String(TARGET_ETAB_ID);

    const isCompleted =
      p.status === "completed";

    /*
      Charmille :
      durée brute = durée payée + pause 30 min
    */

    const dureeBrute =
      isTargetEtab
        ? dureePayee + 30
        : dureePayee;

    /*
      Durée réellement facturée
    */

    const dureeFinal =
      p.actual_duration_payee ??
      p.actual_duration ??
      p.dureeMinutes ??
      0;

    let pauseDeduite =
      Number(
        p.pause_non_payee_minutes
      ) || 0;

    if (
      isTargetEtab &&
      p.pause_non_payee_appliquee
    ) {
      pauseDeduite = 30;
    }

    return {
      dureeInitiale: dureeBrute,
      dureeBrute,
      dureeFinal:
        Number(dureeFinal) || 0,
      pauseDeduite,
      isTargetEtab,
      isCompleted,
    };
  };

  /* =========================================================
     CALCUL TOTALS
  ========================================================= */

  const calculateTotals = (
    prestations,
    role
  ) => {
    const completedPrestations =
      prestations.filter(
        (p) =>
          p.status === "completed"
      );

    const gross =
      completedPrestations.reduce(
        (acc, p) => {
          return (
            acc +
            Number(
              p.gain_final ??
                p.final_rate ??
                0
            )
          );
        },
        0
      );

    const discountRate =
      role === "nurse"
        ? 0.09
        : 0.07;

    const discount =
      gross * discountRate;

    const net =
      gross - discount;

    return {
      gross,
      discount,
      net,
      discountRate,
    };
  };

  /* =========================================================
     CALCUL HEURES
  ========================================================= */

  const analyzeHours = (
    prestations
  ) => {
    let totalPrev = 0;
    let weekPrev = 0;
    let weekendPrev = 0;

    let totalReal = 0;
    let weekReal = 0;
    let weekendReal = 0;

    prestations.forEach((p) => {
      if (!p.dateStart) return;

      const dt =
        new Date(p.dateStart);

      if (
        isNaN(dt.getTime())
      ) {
        return;
      }

      const day =
        dt.getDay();

      const planned =
        Number(p.dureeMinutes) || 0;

      const actual =
        Math.round(
          Number(
            p.actual_duration
          ) || 0
        );

      totalPrev += planned;
      totalReal += actual;

      if (
        day === 0 ||
        day === 6
      ) {
        weekendPrev += planned;
        weekendReal += actual;
      } else {
        weekPrev += planned;
        weekReal += actual;
      }
    });

    return {
      totalHoursPlanned:
        (totalPrev / 60).toFixed(2),

      weekHoursPlanned:
        (weekPrev / 60).toFixed(2),

      weekendHoursPlanned:
        (weekendPrev / 60).toFixed(2),

      totalHoursReal:
        (totalReal / 60).toFixed(2),

      weekHoursReal:
        (weekReal / 60).toFixed(2),

      weekendHoursReal:
        (weekendReal / 60).toFixed(2),
    };
  };

  /* =========================================================
     CHARGER FICHE USER
  ========================================================= */

const fetchUserPayrolls = async (userId, selectedUser) => {
  setPayrollLoading(true);

  try {
    console.log("======================================");
    console.log("🔍 USER SÉLECTIONNÉ COMPLET :", selectedUser);
    console.log("user.id :", selectedUser?.id);
    console.log("user._id :", selectedUser?._id);
    console.log("userId reçu :", userId);
    console.log("email :", selectedUser?.email);
    console.log("======================================");

    const idsToTry = [
      selectedUser?.id,
      selectedUser?._id,
      userId,
    ].filter(
      (value, index, array) =>
        value &&
        array.indexOf(value) === index
    );

    console.log("IDs À TESTER :", idsToTry);

    let allPrestations = [];
    let successfulId = null;

    /*
     * On teste tous les identifiants connus du user.
     * Dès qu'une route retourne des prestations,
     * on garde cette réponse.
     */
    for (const id of idsToTry) {
      try {
        console.log(
          `➡️ TEST /prestations/user/${id}`
        );

        const response = await axiosInstance.get(
          `/prestations/user/${id}`
        );

        console.log(
          `⬅️ RÉPONSE POUR ${id} :`,
          response.data
        );

        const data = Array.isArray(response.data)
          ? response.data
          : [];

        if (data.length > 0) {
          allPrestations = data;
          successfulId = id;

          console.log(
            `✅ ${data.length} PRESTATION(S) TROUVÉE(S) AVEC :`,
            id
          );

          break;
        }
      } catch (error) {
        console.warn(
          `⚠️ ÉCHEC AVEC ID ${id} :`,
          error?.response?.status,
          error?.response?.data
        );
      }
    }

    console.log(
      "📦 TOTAL PRESTATIONS RETENUES :",
      allPrestations.length
    );

    console.log(
      "🔑 IDENTIFIANT AYANT FONCTIONNÉ :",
      successfulId
    );

    /*
     * IMPORTANT :
     * on détermine les années réellement présentes
     * dans les prestations.
     */
    const availableYears = [
      ...new Set(
        allPrestations
          .map((p) => {
            if (!p.dateStart) return null;

            const dt = new Date(p.dateStart);

            if (isNaN(dt.getTime())) return null;

            return dt.getFullYear().toString();
          })
          .filter(Boolean)
      ),
    ];

    console.log(
      "📅 ANNÉES DISPONIBLES :",
      availableYears
    );

    /*
     * On essaie 2026 en priorité.
     * Si aucune prestation n'existe en 2026,
     * on prend automatiquement l'année la plus récente.
     */
    let selectedYear = new Date()
      .getFullYear()
      .toString();

    if (
      allPrestations.length > 0 &&
      !availableYears.includes(selectedYear)
    ) {
      selectedYear = [...availableYears].sort(
        (a, b) => Number(b) - Number(a)
      )[0];
    }

    /*
     * Filtre de l'année sélectionnée.
     */
    let filtered = allPrestations.filter((p) => {
      if (!p.dateStart) return false;

      const dt = new Date(p.dateStart);

      if (isNaN(dt.getTime())) return false;

      return (
        dt.getFullYear().toString() === selectedYear
      );
    });

    /*
     * Sécurité :
     * si les prestations existent mais que les dates
     * sont anciennes ou dans un format problématique,
     * on ne vide pas toute la fiche.
     */
    if (
      allPrestations.length > 0 &&
      filtered.length === 0
    ) {
      console.warn(
        "⚠️ Le filtre année a tout supprimé. Affichage de toutes les prestations."
      );

      filtered = allPrestations;
    }

    console.log(
      `📋 PRESTATIONS AFFICHÉES (${selectedYear}) :`,
      filtered
    );

    const totals = calculateTotals(
      filtered,
      selectedUser?.role
    );

    const hours = analyzeHours(filtered);

    setPayrollModal({
      open: true,

      user: selectedUser,

      prestations: allPrestations,

      selectedMonth: null,

      selectedYear,

      filteredPrestations: filtered,

      totals,

      hours,
    });

    if (allPrestations.length === 0) {
      toast.warning(
        `Aucune prestation trouvée pour ${selectedUser?.first_name || ""} ${selectedUser?.last_name || ""}`
      );
    } else {
      toast.success(
        `${allPrestations.length} prestation(s) chargée(s) pour ${selectedUser?.first_name || ""} ${selectedUser?.last_name || ""}`
      );
    }
  } catch (error) {
    console.error(
      "❌ ERREUR CHARGEMENT FICHE ADMIN :",
      error
    );

    console.error(
      "RÉPONSE BACKEND :",
      error?.response?.data
    );

    toast.error(
      error?.response?.data?.detail ||
        "Erreur lors du chargement de la fiche de paie"
    );
  } finally {
    setPayrollLoading(false);
  }
};

  /* =========================================================
     FILTRES FICHE DE PAIE
  ========================================================= */

  const updateFilters =
    useCallback(
      (month, year) => {
        const filtered =
          payrollModal.prestations.filter(
            (p) => {
              if (
                !p.dateStart
              ) {
                return false;
              }

              const dt =
                new Date(
                  p.dateStart
                );

              if (
                isNaN(
                  dt.getTime()
                )
              ) {
                return false;
              }

              const prestationMonth =
                (
                  dt.getMonth() +
                  1
                )
                  .toString()
                  .padStart(
                    2,
                    "0"
                  );

              const prestationYear =
                dt
                  .getFullYear()
                  .toString();

              const monthMatch =
                !month ||
                prestationMonth ===
                  month;

              const yearMatch =
                !year ||
                prestationYear ===
                  year;

              return (
                monthMatch &&
                yearMatch
              );
            }
          );

        console.log(
          "MOIS :",
          month
        );

        console.log(
          "ANNÉE :",
          year
        );

        console.log(
          "PRESTATIONS FILTRÉES :",
          filtered
        );

        const totals =
          calculateTotals(
            filtered,
            payrollModal.user
              ?.role
          );

        const hours =
          analyzeHours(
            filtered
          );

        setPayrollModal(
          (prev) => ({
            ...prev,

            selectedMonth:
              month || null,

            selectedYear:
              year,

            filteredPrestations:
              filtered,

            totals,

            hours,
          })
        );
      },
      [
        payrollModal.prestations,
        payrollModal.user?.role,
      ]
    );

  /* =========================================================
     EXPORT PDF ADMIN
  ========================================================= */

  const exportAdminPayrollPdf =
    () => {
      const selectedUser =
        payrollModal.user;

      const prestations =
        payrollModal.filteredPrestations;

      if (!selectedUser) {
        toast.error(
          "Aucun utilisateur sélectionné"
        );
        return;
      }

      if (
        !prestations ||
        prestations.length === 0
      ) {
        toast.error(
          "Aucune prestation pour cette période"
        );
        return;
      }

      const doc =
        new jsPDF(
          "portrait",
          "pt",
          "a4"
        );

      const pageWidth =
        doc.internal.pageSize.getWidth();

      const logo =
        new Image();

      logo.src =
        "/sanacare.jpg";

      logo.onload = () => {
        doc.addImage(
          logo,
          "JPEG",
          40,
          30,
          90,
          45
        );

        doc.setFont(
          "Helvetica",
          "bold"
        );

        doc.setFontSize(16);

        doc.text(
          "SANA-CARE DIAMOND",
          pageWidth - 40,
          50,
          {
            align: "right",
          }
        );

        doc.setFontSize(10);

        doc.setFont(
          "Helvetica",
          "normal"
        );

        doc.text(
          "Avenue Louise 200, 1050 Bruxelles",
          pageWidth - 40,
          65,
          {
            align: "right",
          }
        );

        doc.text(
          "Sana-carediamond@outlook.com",
          pageWidth - 40,
          80,
          {
            align: "right",
          }
        );

        doc.text(
          "1025.941.977",
          pageWidth - 40,
          95,
          {
            align: "right",
          }
        );

        doc.text(
          "BE71 3632 5061 2169",
          pageWidth - 40,
          110,
          {
            align: "right",
          }
        );

        doc.setLineWidth(1);

        doc.line(
          40,
          125,
          pageWidth - 40,
          125
        );

        const periode =
          payrollModal.selectedMonth
            ? `${payrollModal.selectedMonth}/${payrollModal.selectedYear}`
            : `Année ${payrollModal.selectedYear}`;

        doc.setFont(
          "Helvetica",
          "bold"
        );

        doc.setFontSize(20);

        doc.text(
          `FICHE DE PAIE - ${periode}`,
          pageWidth / 2,
          165,
          {
            align: "center",
          }
        );

        doc.setFontSize(12);

        doc.text(
          "SOIGNANT :",
          40,
          205
        );

        doc.setFontSize(11);

        doc.setFont(
          "Helvetica",
          "normal"
        );

        doc.text(
          `Nom : ${
            selectedUser.first_name ||
            ""
          } ${
            selectedUser.last_name ||
            ""
          }`,
          40,
          225
        );

        doc.text(
          `Email : ${
            selectedUser.email ||
            "—"
          }`,
          40,
          240
        );

        doc.text(
          `Téléphone : ${
            selectedUser.phone ||
            "—"
          }`,
          40,
          255
        );

        doc.text(
          `Adresse : ${
            selectedUser.address ||
            "—"
          }`,
          40,
          270
        );

        doc.setLineWidth(
          0.8
        );

        doc.line(
          40,
          290,
          pageWidth - 40,
          290
        );

        const columns = [
          "Début",
          "Fin",
          "Description",
          "Durée brute",
          "Pause",
          "Durée facturée",
          "Montant (€)",
          "Statut",
        ];

        const rows =
          prestations.map(
            (p) => {
              const details =
                getPrestationDetails(
                  p
                );

              return [
                new Date(
                  p.dateStart
                ).toLocaleDateString(
                  "fr-BE"
                ),

                new Date(
                  p.dateEnd
                ).toLocaleDateString(
                  "fr-BE"
                ),

                p.description ||
                  "—",

                formatDuration(
                  details.dureeInitiale
                ),

                details.pauseDeduite >
                  0 ||
                (details.isTargetEtab &&
                  details.isCompleted)
                  ? `- ${formatDuration(
                      details.pauseDeduite >
                        0
                        ? details.pauseDeduite
                        : 30
                    )}`
                  : "—",

                details.isCompleted &&
                details.dureeFinal !=
                  null
                  ? formatDuration(
                      details.dureeFinal
                    )
                  : "—",

                p.status ===
                "completed"
                  ? Number(
                      p.gain_final ??
                        p.final_rate ??
                        0
                    ).toFixed(
                      2
                    )
                  : "—",

                p.status ||
                  "—",
              ];
            }
          );

        autoTable(doc, {
          startY: 310,

          head: [columns],

          body: rows,

          styles: {
            fontSize: 8,
            cellPadding: 4,
          },

          headStyles: {
            fillColor: [
              212,
              235,
              235,
            ],
            textColor: 20,
            fontSize: 9,
            halign:
              "center",
          },

          margin: {
            left: 40,
            right: 40,
          },
        });

        const totals =
          payrollModal.totals;

        const finalY =
          (doc.lastAutoTable
            ?.finalY ||
            310) + 30;

        doc.setFont(
          "Helvetica",
          "italic"
        );

        doc.setFontSize(9);

        doc.text(
          `* Pause de 30 min déduite uniquement pour les prestations effectuées dans l'établissement « ${targetEtabName} » (accord spécifique).`,
          40,
          finalY,
          {
            maxWidth:
              pageWidth -
              80,
          }
        );

        doc.setFont(
          "Helvetica",
          "bold"
        );

        doc.setFontSize(14);

        doc.text(
          `TOTAL BRUT : ${Number(
            totals.gross ||
              0
          ).toFixed(2)} €`,
          pageWidth - 40,
          finalY + 30,
          {
            align: "right",
          }
        );

        doc.setFont(
          "Helvetica",
          "normal"
        );

        doc.text(
          `Prélèvement (${(
            Number(
              totals.discountRate
            ) * 100
          ).toFixed(
            0
          )} %) : -${Number(
            totals.discount ||
              0
          ).toFixed(2)} €`,
          pageWidth - 40,
          finalY + 50,
          {
            align: "right",
          }
        );

        doc.setFont(
          "Helvetica",
          "bold"
        );

        doc.text(
          `TOTAL NET : ${Number(
            totals.net || 0
          ).toFixed(2)} €`,
          pageWidth - 40,
          finalY + 70,
          {
            align: "right",
          }
        );

        const safeFirstName =
          (
            selectedUser.first_name ||
            "soignant"
          ).replace(
            /\s+/g,
            "_"
          );

        const safeLastName =
          (
            selectedUser.last_name ||
            ""
          ).replace(
            /\s+/g,
            "_"
          );

        const month =
          payrollModal.selectedMonth ||
          "annee";

        doc.save(
          `fiche_de_paie_${safeFirstName}_${safeLastName}_${month}_${payrollModal.selectedYear}.pdf`
        );
      };

      logo.onerror =
        () => {
          toast.error(
            "Impossible de charger le logo Sana Care"
          );
        };
    };

  /* =========================================================
     FERMER MODAL
  ========================================================= */

  const closePayrollModal =
    () => {
      setPayrollModal({
        open: false,

        user: null,

        prestations: [],

        selectedMonth:
          null,

        selectedYear:
          new Date()
            .getFullYear()
            .toString(),

        filteredPrestations:
          [],

        totals: {
          gross: 0,
          discount: 0,
          net: 0,
          discountRate: 0,
        },

        hours: {},
      });
    };

  /* =========================================================
     APPROUVER / REJETER
  ========================================================= */

  const handleApprove =
    async (userId, e) => {
      e.stopPropagation();

      try {
        await axiosInstance.post(
          `/users/${userId}/approve`
        );

        toast.success(
          "Utilisateur approuvé"
        );

        fetchUsers();
      } catch {
        toast.error(
          "Échec de l'approbation"
        );
      }
    };

  const handleReject =
    async (userId, e) => {
      e.stopPropagation();

      try {
        await axiosInstance.post(
          `/users/${userId}/reject`
        );

        toast.success(
          "Utilisateur rejeté"
        );

        fetchUsers();
      } catch {
        toast.error(
          "Échec du rejet"
        );
      }
    };

  /* =========================================================
     SUPPRESSION
  ========================================================= */

  const handleDeleteUser =
    async (userId, e) => {
      e.stopPropagation();

      if (
        !window.confirm(
          "Supprimer définitivement cet utilisateur ?"
        )
      ) {
        return;
      }

      try {
        await axiosInstance.delete(
          `/users/admin/${userId}`
        );

        toast.success(
          "Utilisateur supprimé"
        );

        setUsers(
          (prev) =>
            prev.filter(
              (u) =>
                u.id !==
                userId
            )
        );
      } catch (error) {
        toast.error(
          error.response?.data
            ?.detail ||
            "Échec de la suppression"
        );
      }
    };

  /* =========================================================
     BADGES
  ========================================================= */

  const getStatusBadge =
    (status) => {
      const variants = {
        pending:
          "bg-orange-100 text-orange-700",

        approved:
          "bg-emerald-100 text-emerald-700",

        rejected:
          "bg-red-100 text-red-700",
      };

      return (
        <Badge
          className={
            variants[
              status
            ] ||
            "bg-gray-500 text-white"
          }
        >
          {status ===
          "pending"
            ? "En attente"
            : status ===
              "approved"
            ? "Approuvé"
            : "Rejeté"}
        </Badge>
      );
    };

  const getRoleBadge =
    (role) => {
      switch (role) {
        case "admin":
          return (
            <Badge className="bg-gray-100 text-gray-700">
              🛡 Admin
            </Badge>
          );

        case "nurse":
          return (
            <Badge className="bg-blue-100 text-blue-700">
              🩺 Infirmier
            </Badge>
          );

        case "caregiver":
          return (
            <Badge className="bg-green-100 text-green-700">
              🧑‍⚕️ Aide-soignant
            </Badge>
          );

        case "titulaire_domicile":
          return (
            <Badge className="bg-cyan-100 text-cyan-700">
              🏠 Titulaire soins à domicile
            </Badge>
          );

        case "coordinateur":
          return (
            <Badge className="bg-purple-100 text-purple-700">
              📋 Coordinateur
            </Badge>
          );

        default:
          return (
            <Badge className="bg-slate-100 text-slate-700">
              👤 Utilisateur
            </Badge>
          );
      }
    };

  /* =========================================================
     LOADING
  ========================================================= */

  if (loading) {
    return (
      <Layout title="Gestion des utilisateurs">
        <div className="flex justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#8aa9a9]" />
        </div>
      </Layout>
    );
  }

  /* =========================================================
     FILTRE USERS
  ========================================================= */

  const filteredUsers =
    users.filter((u) => {
      const text =
        (
          searchTerm ||
          ""
        ).toLowerCase();

      const matchText =
        (
          u.first_name ||
          ""
        )
          .toLowerCase()
          .includes(text) ||
        (
          u.last_name ||
          ""
        )
          .toLowerCase()
          .includes(text) ||
        (
          u.email ||
          ""
        )
          .toLowerCase()
          .includes(text);

      const matchRole =
        roleFilter ===
        "all"
          ? true
          : u.role ===
            roleFilter;

      const matchStatus =
        statusFilter ===
        "all"
          ? true
          : u.status ===
            statusFilter;

      return (
        matchText &&
        matchRole &&
        matchStatus
      );
    });

  /* =========================================================
     STATS
  ========================================================= */

  const stats = {
    total: users.length,

    nurses:
      users.filter(
        (u) =>
          u.role ===
          "nurse"
      ).length,

    caregivers:
      users.filter(
        (u) =>
          u.role ===
          "caregiver"
      ).length,

    titulaireDomicile:
      users.filter(
        (u) =>
          u.role ===
          "titulaire_domicile"
      ).length,

    approved:
      users.filter(
        (u) =>
          u.status ===
          "approved"
      ).length,

    pending:
      users.filter(
        (u) =>
          u.status ===
          "pending"
      ).length,
  };

  /* =========================================================
     AFFICHAGE
  ========================================================= */

  return (
    <Layout title="Gestion des utilisateurs">

      {/* ================= STATS ================= */}

      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4 mb-6">

        <Card className="border-0 shadow-md">
          <CardContent className="p-5">
            <p className="text-gray-500 text-sm">
              Total utilisateurs
            </p>
            <p className="text-3xl font-bold">
              {stats.total}
            </p>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardContent className="p-5">
            <p className="text-gray-500 text-sm">
              Infirmiers
            </p>
            <p className="text-3xl font-bold text-blue-600">
              {stats.nurses}
            </p>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardContent className="p-5">
            <p className="text-gray-500 text-sm">
              Aides-soignants
            </p>
            <p className="text-3xl font-bold text-green-600">
              {stats.caregivers}
            </p>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardContent className="p-5">
            <p className="text-gray-500 text-sm">
              Titulaires domicile
            </p>
            <p className="text-3xl font-bold text-cyan-600">
              {
                stats.titulaireDomicile
              }
            </p>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardContent className="p-5">
            <p className="text-gray-500 text-sm">
              Approuvés
            </p>
            <p className="text-3xl font-bold text-emerald-600">
              {stats.approved}
            </p>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-md">
          <CardContent className="p-5">
            <p className="text-gray-500 text-sm">
              En attente
            </p>
            <p className="text-3xl font-bold text-orange-500">
              {stats.pending}
            </p>
          </CardContent>
        </Card>
      </div>

      {/* ================= FILTRES ================= */}

      <div className="mb-4 flex flex-col md:flex-row gap-3 md:items-end">

        <div className="flex-1">
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Rechercher
          </label>

          <input
            type="text"
            className="w-full border border-[#d4ebeb] rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#9bbcbc]"
            placeholder="Nom, prénom ou email…"
            value={
              searchTerm
            }
            onChange={(
              e
            ) =>
              setSearchTerm(
                e.target
                  .value
              )
            }
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Rôle
          </label>

          <Select
            value={
              roleFilter
            }
            onValueChange={
              setRoleFilter
            }
          >
            <SelectTrigger className="w-[180px] bg-white">
              <SelectValue />
            </SelectTrigger>

            <SelectContent>
              <SelectItem value="all">
                Tous
              </SelectItem>

              <SelectItem value="nurse">
                Infirmier
              </SelectItem>

              <SelectItem value="caregiver">
                Aide-soignant
              </SelectItem>

              <SelectItem value="titulaire_domicile">
                Titulaire soins à domicile
              </SelectItem>

              <SelectItem value="admin">
                Admin
              </SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Statut
          </label>

          <Select
            value={
              statusFilter
            }
            onValueChange={
              setStatusFilter
            }
          >
            <SelectTrigger className="w-[160px] bg-white">
              <SelectValue />
            </SelectTrigger>

            <SelectContent>
              <SelectItem value="all">
                Tous
              </SelectItem>

              <SelectItem value="pending">
                En attente
              </SelectItem>

              <SelectItem value="approved">
                Approuvé
              </SelectItem>

              <SelectItem value="rejected">
                Rejeté
              </SelectItem>
            </SelectContent>
          </Select>
        </div>
      </div>

      <p className="text-sm text-gray-500 mb-4">
        {
          filteredUsers.length
        }{" "}
        utilisateur(s) affiché(s)
      </p>

      {/* ================= USERS ================= */}

      <div className="space-y-4">

        {filteredUsers.length ===
        0 ? (
          <Card>
            <CardContent className="py-12 text-center text-gray-500">
              Aucun utilisateur trouvé
            </CardContent>
          </Card>
        ) : (
          filteredUsers.map(
            (user) => (
              <Card
                key={
                  user.id
                }
                className="border-[#d4ebeb] hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
              >
                <CardContent className="p-7 flex flex-col md:flex-row md:items-center justify-between gap-4">

                  <div className="flex items-center space-x-4">

                    {user.profile_photo ? (
                      <img
                        src={
                          user.profile_photo.startsWith(
                            "http"
                          )
                            ? user.profile_photo
                            : `${process.env.REACT_APP_BACKEND_URL}${user.profile_photo}`
                        }
                        alt={`${user.first_name} ${user.last_name}`}
                        className="w-16 h-16 rounded-full border-2 border-[#d4ebeb] object-cover"
                      />
                    ) : (
                      <div className="w-16 h-16 rounded-full bg-[#d4ebeb] flex items-center justify-center">

                        <span className="text-2xl font-bold text-slate-700">
                          {(user
                            .first_name?.[0] ||
                            "") +
                            (user
                              .last_name?.[0] ||
                              "")}
                        </span>

                      </div>
                    )}

                    <div>

                      <h3 className="text-xl font-bold text-gray-900">
                        {
                          user.first_name
                        }{" "}
                        {
                          user.last_name
                        }
                      </h3>

                      <div className="flex gap-2 mt-2 flex-wrap">

                        {getRoleBadge(
                          user.role
                        )}

                        {getStatusBadge(
                          user.status
                        )}

                        {user.role !==
                          "admin" &&
                          (user.documents_complete ===
                          true ? (
                            <Badge className="bg-emerald-100 text-emerald-700">
                              ✓ Dossier en ordre
                            </Badge>
                          ) : user.documents_complete ===
                            false ? (
                            <Badge className="bg-red-100 text-red-700">
                              ⚠ Dossier pas en ordre
                            </Badge>
                          ) : (
                            <Badge className="bg-gray-100 text-gray-700">
                              État du dossier inconnu
                            </Badge>
                          ))}
                      </div>

                      {user.role !==
                        "admin" &&
                        user.documents_complete ===
                          false && (
                          <div className="mt-3 p-3 rounded-lg bg-red-50 border border-red-200">

                            <p className="text-sm font-semibold text-red-700">
                              ⚠{" "}
                              {user
                                .missing_documents
                                ?.length ||
                                0}{" "}
                              document(s)
                              manquant(s)
                            </p>

                            <p className="text-xs text-red-600 mt-1">
                              {user.missing_documents?.join(
                                " • "
                              )}
                            </p>

                          </div>
                        )}

                      <p className="text-gray-600 mt-3">
                        📧{" "}
                        {
                          user.email
                        }
                      </p>

                      <p className="text-gray-600">
                        📞{" "}
                        {user.phone ||
                          "Non renseigné"}
                      </p>

                      <p className="text-gray-500 text-sm mt-2">
                        Inscrit le{" "}
                        {user.created_at
                          ? new Date(
                              user.created_at
                            ).toLocaleDateString()
                          : "—"}
                      </p>

                    </div>
                  </div>

                  <div className="flex flex-col gap-3">

                    {user.status ===
                      "pending" && (
                      <div className="flex gap-2">

                        <Button
                          onClick={(
                            e
                          ) =>
                            handleApprove(
                              user.id,
                              e
                            )
                          }
                          className="bg-green-600 hover:bg-green-700 text-white"
                        >
                          <UserCheck
                            size={
                              16
                            }
                            className="mr-1"
                          />
                          Approuver
                        </Button>

                        <Button
                          onClick={(
                            e
                          ) =>
                            handleReject(
                              user.id,
                              e
                            )
                          }
                          variant="destructive"
                        >
                          <UserX
                            size={
                              16
                            }
                            className="mr-1"
                          />
                          Rejeter
                        </Button>

                      </div>
                    )}

                    <Link
                      to={`/users/${user.id}`}
                      className="btn btn-outline w-full"
                    >
                      Voir le profil
                    </Link>

                    <Button
                      onClick={() =>
                        fetchUserPayrolls(
                          user.id,
                          user
                        )
                      }
                      disabled={
                        payrollLoading
                      }
                      variant="outline"
                      className="w-full rounded-xl"
                    >
                      <FileText
                        size={
                          16
                        }
                        className="mr-2"
                      />

                      {payrollLoading
                        ? "Chargement..."
                        : "Fiche de paie"}
                    </Button>

                    <Button
                      onClick={(
                        e
                      ) =>
                        handleDeleteUser(
                          user.id,
                          e
                        )
                      }
                      variant="destructive"
                      className="w-full rounded-xl"
                    >
                      Supprimer
                    </Button>

                  </div>

                </CardContent>
              </Card>
            )
          )
        )}
      </div>

      {/* =====================================================
          MODAL FICHE DE PAIE
      ===================================================== */}

      {payrollModal.open && (
        <div className="fixed inset-0 bg-black bg-opacity-75 z-50 flex items-center justify-center p-4">

          <div className="bg-white rounded-2xl max-w-6xl max-h-[95vh] w-full flex flex-col shadow-2xl">

            {/* HEADER */}

            <div className="bg-[#d4ebeb] text-slate-800 p-6 rounded-t-2xl flex flex-col lg:flex-row lg:items-center justify-between gap-4">

              <div>
                <h2 className="text-3xl font-bold mb-1">
                  Fiche de paie détaillée
                </h2>

                <p className="text-slate-600 text-lg">
                  {
                    payrollModal
                      .user
                      ?.first_name
                  }{" "}
                  {
                    payrollModal
                      .user
                      ?.last_name
                  }
                </p>
              </div>

              <div className="flex items-center gap-3 flex-wrap">

                {/* MOIS */}

                <Select
                  value={
                    payrollModal.selectedMonth ||
                    undefined
                  }
                  onValueChange={(
                    value
                  ) =>
                    updateFilters(
                      value,
                      payrollModal.selectedYear
                    )
                  }
                >
                  <SelectTrigger className="w-[150px] bg-white">
                    <SelectValue placeholder="Tous les mois" />
                  </SelectTrigger>

                  <SelectContent>

                    {Array.from({
                      length: 12,
                    }).map(
                      (
                        _,
                        i
                      ) => {
                        const value =
                          (
                            i +
                            1
                          )
                            .toString()
                            .padStart(
                              2,
                              "0"
                            );

                        return (
                          <SelectItem
                            key={
                              value
                            }
                            value={
                              value
                            }
                          >
                            {new Date(
                              0,
                              i
                            ).toLocaleString(
                              "fr-FR",
                              {
                                month:
                                  "long",
                              }
                            )}
                          </SelectItem>
                        );
                      }
                    )}

                  </SelectContent>
                </Select>

                {/* ANNÉE */}

                <Select
                  value={
                    payrollModal.selectedYear
                  }
                  onValueChange={(
                    value
                  ) =>
                    updateFilters(
                      payrollModal.selectedMonth,
                      value
                    )
                  }
                >
                  <SelectTrigger className="w-[110px] bg-white">
                    <SelectValue placeholder="Année" />
                  </SelectTrigger>

                  <SelectContent>

                    {Array.from(
                      {
                        length:
                          5,
                      },
                      (
                        _,
                        i
                      ) =>
                        (
                          2023 +
                          i
                        ).toString()
                    ).map(
                      (
                        year
                      ) => (
                        <SelectItem
                          key={
                            year
                          }
                          value={
                            year
                          }
                        >
                          {
                            year
                          }
                        </SelectItem>
                      )
                    )}

                  </SelectContent>
                </Select>

                {/* PDF */}

                <Button
                  onClick={
                    exportAdminPayrollPdf
                  }
                  disabled={
                    !payrollModal.filteredPrestations ||
                    payrollModal
                      .filteredPrestations
                      .length ===
                      0
                  }
                  className="bg-white text-slate-700 hover:bg-slate-50 font-bold px-6 flex items-center gap-2"
                >
                  <Download
                    size={
                      18
                    }
                  />
                  Télécharger la fiche
                </Button>

                <Button
                  onClick={
                    closePayrollModal
                  }
                  variant="ghost"
                  size="sm"
                >
                  <X
                    size={
                      24
                    }
                  />
                </Button>

              </div>
            </div>

            {/* INFO PAUSE */}

            <div className="p-4 bg-[#f3fafa] border-b border-[#d4ebeb]">

              <p className="text-sm text-gray-700">
                <b>
                  📋 Important :
                </b>{" "}
                Pause de 30 min
                déduite{" "}
                <b>
                  UNIQUEMENT
                </b>{" "}
                pour les
                prestations de
                l'établissement{" "}
                <span className="font-bold text-slate-700">
                  {
                    targetEtabName
                  }
                </span>
              </p>

            </div>

            {/* TABLE */}

            <div className="flex-1 overflow-auto p-6">

              <div className="overflow-x-auto">

                <table className="w-full text-xs border border-gray-300">

                  <thead className="bg-[#d4ebeb] sticky top-0">

                    <tr>
                      <th className="border p-2">
                        Date début
                      </th>

                      <th className="border p-2">
                        Date fin
                      </th>

                      <th className="border p-2">
                        Description
                      </th>

                      <th className="border p-2">
                        Durée brute
                      </th>

                      <th className="border p-2">
                        Pause
                      </th>

                      <th className="border p-2">
                        Facturée
                      </th>

                      <th className="border p-2">
                        Montant
                      </th>

                      <th className="border p-2">
                        Statut
                      </th>
                    </tr>

                  </thead>

                  <tbody>

                    {payrollModal
                      .filteredPrestations
                      .length ===
                    0 ? (

                      <tr>
                        <td
                          colSpan={
                            8
                          }
                          className="border p-8 text-center text-gray-500"
                        >
                          Aucune prestation pour cette période
                        </td>
                      </tr>

                    ) : (

                      payrollModal.filteredPrestations.map(
                        (
                          p
                        ) => {
                          const details =
                            getPrestationDetails(
                              p
                            );

                          return (
                            <tr
                              key={
                                p._id ||
                                p.id
                              }
                              className="hover:bg-[#f5fbfb]"
                            >

                              <td className="border px-2 py-2">
                                {new Date(
                                  p.dateStart
                                ).toLocaleDateString()}
                              </td>

                              <td className="border px-2 py-2">
                                {p.dateEnd
                                  ? new Date(
                                      p.dateEnd
                                    ).toLocaleDateString()
                                  : "—"}
                              </td>

                              <td className="border px-2 py-2">
                                {p.description ||
                                  "—"}
                              </td>

                              <td className="border px-2 py-2 text-center">
                                {formatDuration(
                                  details.dureeInitiale
                                )}
                              </td>

                              <td className="border px-2 py-2 text-orange-600 font-semibold text-center">

                                {details.pauseDeduite >
                                  0 ||
                                (details.isTargetEtab &&
                                  details.isCompleted)
                                  ? `- ${formatDuration(
                                      details.pauseDeduite >
                                        0
                                        ? details.pauseDeduite
                                        : 30
                                    )}`
                                  : "—"}

                              </td>

                              <td className="border px-2 py-2 font-semibold text-center">

                                {details.isCompleted &&
                                details.dureeFinal !=
                                  null
                                  ? formatDuration(
                                      details.dureeFinal
                                    )
                                  : "—"}

                              </td>

                              <td className="border px-2 py-2 font-semibold text-right">

                                {p.status ===
                                "completed"
                                  ? `${Number(
                                      p.gain_final ??
                                        p.final_rate ??
                                        0
                                    ).toFixed(
                                      2
                                    )} €`
                                  : "—"}

                              </td>

                              <td
                                className={`border px-2 py-2 text-center font-semibold ${
                                  p.status ===
                                  "completed"
                                    ? "text-green-600 bg-green-50"
                                    : p.status ===
                                      "in_progress"
                                    ? "text-blue-600 bg-blue-50"
                                    : p.status ===
                                      "assigned"
                                    ? "text-amber-600 bg-amber-50"
                                    : p.status ===
                                      "accepted"
                                    ? "text-emerald-600 bg-emerald-50"
                                    : "text-gray-500"
                                }`}
                              >
                                {p.status ||
                                  "—"}
                              </td>

                            </tr>
                          );
                        }
                      )

                    )}

                  </tbody>

                </table>

              </div>
            </div>

            {/* ================= RÉCAP ================= */}

            <div className="bg-[#f3fafa] border-t border-[#d4ebeb] p-6 shrink-0">

              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">

                <div>

                  <h3 className="font-semibold mb-2">
                    Prévisionnel :
                  </h3>

                  <p>
                    Heures totales :{" "}
                    <b>
                      {payrollModal
                        .hours
                        ?.totalHoursPlanned ||
                        0}{" "}
                      h
                    </b>
                  </p>

                  <p className="text-xs mt-1">
                    Semaine :{" "}
                    <b>
                      {payrollModal
                        .hours
                        ?.weekHoursPlanned ||
                        0}{" "}
                      h
                    </b>{" "}
                    | Week-end :{" "}
                    <b>
                      {payrollModal
                        .hours
                        ?.weekendHoursPlanned ||
                        0}{" "}
                      h
                    </b>
                  </p>

                </div>

                <div>

                  <h3 className="font-semibold mb-2">
                    Effectif :
                  </h3>

                  <p>
                    Heures totales :{" "}
                    <b>
                      {payrollModal
                        .hours
                        ?.totalHoursReal ||
                        0}{" "}
                      h
                    </b>
                  </p>

                  <p className="text-xs mt-1">
                    Semaine :{" "}
                    <b>
                      {payrollModal
                        .hours
                        ?.weekHoursReal ||
                        0}{" "}
                      h
                    </b>{" "}
                    | Week-end :{" "}
                    <b>
                      {payrollModal
                        .hours
                        ?.weekendHoursReal ||
                        0}{" "}
                      h
                    </b>
                  </p>

                </div>

                <div>

                  <h3 className="font-semibold mb-2">
                    Financier :
                  </h3>

                  <p>
                    Total brut :{" "}
                    <b>
                      {Number(
                        payrollModal
                          .totals
                          ?.gross ||
                          0
                      ).toFixed(
                        2
                      )}{" "}
                      €
                    </b>
                  </p>

                  <p>
                    Prélèvement{" "}
                    {(
                      Number(
                        payrollModal
                          .totals
                          ?.discountRate ||
                          0
                      ) *
                      100
                    ).toFixed(
                      0
                    )}
                    % :{" "}
                    <b>
                      -
                      {Number(
                        payrollModal
                          .totals
                          ?.discount ||
                          0
                      ).toFixed(
                        2
                      )}{" "}
                      €
                    </b>
                  </p>

                  <p className="text-2xl font-bold text-slate-700 mt-2">
                    Net :{" "}
                    {Number(
                      payrollModal
                        .totals
                        ?.net ||
                        0
                    ).toFixed(
                      2
                    )}{" "}
                    €
                  </p>

                </div>

              </div>

            </div>

          </div>

        </div>
      )}

    </Layout>
  );
}